import React from "react";

const GreenCardBag = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 8.63005C16.09 8.63005 15.75 8.29005 15.75 7.88005V6.50005C15.75 5.45006 15.3 4.43005 14.52 3.72005C13.73 3.00005 12.71 2.67005 11.63 2.77005C9.83 2.94005 8.25 4.78005 8.25 6.70005V7.67005C8.25 8.08005 7.91 8.42005 7.5 8.42005C7.09 8.42005 6.75 8.08005 6.75 7.67005V6.69005C6.75 4.00005 8.92 1.52005 11.49 1.27005C12.99 1.13005 14.43 1.60005 15.53 2.61005C16.62 3.60005 17.25 5.02005 17.25 6.50005V7.88005C17.25 8.29005 16.91 8.63005 16.5 8.63005Z"
          fill="#40B2AA"
        />
        <path
          d="M14.9998 22.75H8.99982C4.37982 22.75 3.51982 20.6 3.29982 18.51L2.54982 12.52C2.43982 11.44 2.39982 9.89 3.44982 8.73C4.34982 7.73 5.83982 7.25 7.99982 7.25H15.9998C18.1698 7.25 19.6598 7.74 20.5498 8.73C21.5898 9.89 21.5598 11.44 21.4498 12.5L20.6998 18.51C20.4798 20.6 19.6198 22.75 14.9998 22.75ZM7.99982 8.75C6.30982 8.75 5.14982 9.08 4.55982 9.74C4.06982 10.28 3.90982 11.11 4.03982 12.35L4.78982 18.34C4.95982 19.94 5.39982 21.26 8.99982 21.26H14.9998C18.5998 21.26 19.0398 19.95 19.2098 18.36L19.9598 12.35C20.0898 11.13 19.9298 10.3 19.4398 9.75C18.8498 9.08 17.6898 8.75 15.9998 8.75H7.99982Z"
          fill="#40B2AA"
        />
        <path
          d="M15.4202 13.1499C14.8602 13.1499 14.4102 12.6999 14.4102 12.1499C14.4102 11.5999 14.8602 11.1499 15.4102 11.1499C15.9602 11.1499 16.4102 11.5999 16.4102 12.1499C16.4102 12.6999 15.9702 13.1499 15.4202 13.1499Z"
          fill="#40B2AA"
        />
        <path
          d="M8.42016 13.1499C7.86016 13.1499 7.41016 12.6999 7.41016 12.1499C7.41016 11.5999 7.86016 11.1499 8.41016 11.1499C8.96016 11.1499 9.41016 11.5999 9.41016 12.1499C9.41016 12.6999 8.97016 13.1499 8.42016 13.1499Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};
const FullStarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clip-path="url(#clip0_2868_6226)">
      <path
        d="M7.46003 0.349973L9.12003 3.69997C9.1695 3.78321 9.23778 3.85369 9.3194 3.90579C9.40102 3.95789 9.4937 3.99014 9.59003 3.99997L13.29 4.53997C13.395 4.56086 13.4926 4.60899 13.5731 4.67954C13.6536 4.75008 13.7141 4.84056 13.7485 4.94188C13.783 5.04321 13.7902 5.15181 13.7694 5.2568C13.7486 5.36178 13.7005 5.45944 13.63 5.53997L11 8.23997C10.9302 8.31195 10.8777 8.39889 10.8465 8.49419C10.8153 8.58949 10.8063 8.69065 10.82 8.78997L11.46 12.48C11.4788 12.5938 11.4655 12.7106 11.4216 12.8172C11.3777 12.9239 11.3048 13.0162 11.2113 13.0837C11.1178 13.1512 11.0073 13.1913 10.8923 13.1995C10.7772 13.2077 10.6621 13.1836 10.56 13.13L7.20003 11.39C7.10973 11.3458 7.01054 11.3228 6.91003 11.3228C6.80951 11.3228 6.71032 11.3458 6.62003 11.39L3.31003 13.13C3.20791 13.1836 3.09285 13.2077 2.97779 13.1995C2.86273 13.1913 2.75223 13.1512 2.65872 13.0837C2.56521 13.0162 2.49239 12.9239 2.44846 12.8172C2.40453 12.7106 2.39121 12.5938 2.41003 12.48L3.00003 8.78997C3.01743 8.69138 3.01108 8.59007 2.98152 8.49442C2.95196 8.39877 2.90002 8.31155 2.83003 8.23997L0.190025 5.62997C0.119544 5.54944 0.0714922 5.45178 0.0506932 5.3468C0.0298943 5.24182 0.0370808 5.13321 0.0715312 5.03188C0.105982 4.93056 0.166483 4.84008 0.246962 4.76954C0.32744 4.69899 0.425062 4.65086 0.530025 4.62997L4.23003 3.99997C4.32592 3.98866 4.41802 3.9558 4.49941 3.90385C4.58081 3.85189 4.64939 3.78219 4.70003 3.69997L6.35003 0.349973C6.39857 0.24353 6.4767 0.153294 6.57511 0.0900194C6.67351 0.0267453 6.78803 -0.00689697 6.90503 -0.00689697C7.02202 -0.00689697 7.13654 0.0267453 7.23494 0.0900194C7.33335 0.153294 7.41148 0.24353 7.46003 0.349973Z"
        fill="#FFC01D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2868_6226">
        <rect width="13.82" height="13.2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HalfStarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clip-path="url(#clip0_2868_6230)">
      <path
        d="M7.45998 0.349987L9.11998 3.69999C9.16819 3.7843 9.23615 3.85564 9.31802 3.9079C9.39988 3.96015 9.49321 3.99176 9.58998 3.99999L13.29 4.53999C13.4047 4.55683 13.5124 4.60549 13.6008 4.68045C13.6892 4.75541 13.7549 4.85366 13.7903 4.96404C13.8257 5.07443 13.8294 5.19253 13.8011 5.30495C13.7728 5.41736 13.7135 5.51957 13.63 5.59999L11 8.24999C10.9295 8.32153 10.8766 8.40843 10.8454 8.50385C10.8142 8.59928 10.8055 8.70064 10.82 8.79999L11.46 12.48C11.4772 12.5937 11.4629 12.7099 11.4188 12.816C11.3747 12.9222 11.3023 13.0142 11.2096 13.0822C11.1169 13.1502 11.0074 13.1915 10.8929 13.2017C10.7783 13.2119 10.6632 13.1906 10.56 13.14L7.19998 11.4C7.11119 11.351 7.01141 11.3252 6.90998 11.3252C6.80855 11.3252 6.70878 11.351 6.61998 11.4L3.30998 13.14C3.20673 13.1906 3.09162 13.2119 2.97711 13.2017C2.86259 13.1915 2.75305 13.1502 2.66034 13.0822C2.56763 13.0142 2.49529 12.9222 2.45116 12.816C2.40703 12.7099 2.39279 12.5937 2.40998 12.48L2.99998 8.79999C3.01823 8.7014 3.0123 8.59985 2.98269 8.50406C2.95308 8.40827 2.90068 8.32109 2.82998 8.24999L0.189982 5.63999C0.106482 5.55957 0.0471991 5.45736 0.018865 5.34495C-0.00946911 5.23253 -0.00571971 5.11443 0.0296876 5.00404C0.0650948 4.89366 0.130742 4.79541 0.219175 4.72045C0.307608 4.64549 0.415286 4.59683 0.529982 4.57999L4.22998 3.99999C4.32653 3.99094 4.41953 3.959 4.50127 3.90683C4.583 3.85466 4.65113 3.78375 4.69998 3.69999L6.34998 0.349987C6.40138 0.246762 6.48055 0.159917 6.5786 0.0992123C6.67664 0.0385072 6.78967 0.00634766 6.90498 0.00634766C7.0203 0.00634766 7.13333 0.0385072 7.23137 0.0992123C7.32941 0.159917 7.40858 0.246762 7.45998 0.349987Z"
        fill="#DADADA"
      />
      <path
        d="M6.89992 0V11.32C6.80124 11.322 6.70475 11.3495 6.61992 11.4L3.30992 13.14C3.20667 13.1906 3.09156 13.2119 2.97704 13.2017C2.86253 13.1915 2.75299 13.1502 2.66028 13.0822C2.56757 13.0143 2.49523 12.9222 2.4511 12.816C2.40697 12.7099 2.39273 12.5937 2.40992 12.48L2.99992 8.8C3.01817 8.70141 3.01223 8.59987 2.98263 8.50407C2.95302 8.40828 2.90062 8.3211 2.82992 8.25L0.189921 5.64C0.106421 5.55958 0.0471381 5.45737 0.018804 5.34496C-0.00953015 5.23255 -0.00578074 5.11444 0.0296265 5.00406C0.0650338 4.89367 0.130681 4.79542 0.219114 4.72046C0.307547 4.6455 0.415225 4.59684 0.529921 4.58L4.22992 4C4.32647 3.99095 4.41947 3.95902 4.5012 3.90684C4.58294 3.85467 4.65106 3.78376 4.69992 3.7L6.34992 0.35C6.39911 0.245612 6.47689 0.157316 6.57424 0.0953638C6.6716 0.0334113 6.78453 0.000343622 6.89992 0Z"
        fill="#FFC01D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2868_6230">
        <rect width="13.82" height="13.21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const AddBtn = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="35"
        viewBox="0 0 34 35"
        fill="none"
      >
        <rect y="0.0826416" width="34" height="34" rx="17" fill="#F2F4F3" />
        <path
          d="M23 17.8326H11C10.59 17.8326 10.25 17.4926 10.25 17.0826C10.25 16.6726 10.59 16.3326 11 16.3326H23C23.41 16.3326 23.75 16.6726 23.75 17.0826C23.75 17.4926 23.41 17.8326 23 17.8326Z"
          fill="#40B2AA"
        />
        <path
          d="M17 23.8326C16.59 23.8326 16.25 23.4926 16.25 23.0826V11.0826C16.25 10.6726 16.59 10.3326 17 10.3326C17.41 10.3326 17.75 10.6726 17.75 11.0826V23.0826C17.75 23.4926 17.41 23.8326 17 23.8326Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};

const SearchIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 2C15.97 2 20 6.03 20 11C20 15.97 15.97 20 11 20C6.03 20 2 15.97 2 11C2 7.5 4 4.46 6.93 2.97"
          stroke="#40B2AA"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.071 20.97C19.601 22.57 20.811 22.73 21.741 21.33C22.601 20.05 22.041 19 20.501 19C19.351 19 18.711 19.89 19.071 20.97Z"
          stroke="#40B2AA"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const ShoppingBag = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4904 22.75H7.50042C5.78042 22.75 4.49043 22.29 3.69043 21.38C2.89043 20.47 2.58042 19.15 2.79042 17.44L3.69043 9.94C3.95043 7.73 4.51043 5.75 8.41043 5.75H15.6104C19.5004 5.75 20.0604 7.73 20.3304 9.94L21.2304 17.44C21.4304 19.15 21.1304 20.48 20.3304 21.38C19.5004 22.29 18.2204 22.75 16.4904 22.75ZM8.40042 7.25C5.52042 7.25 5.38042 8.38999 5.17042 10.11L4.27043 17.61C4.12043 18.88 4.30042 19.81 4.81042 20.38C5.32042 20.95 6.22042 21.24 7.50042 21.24H16.4904C17.7704 21.24 18.6704 20.95 19.1804 20.38C19.6904 19.81 19.8704 18.88 19.7204 17.61L18.8204 10.11C18.6104 8.37999 18.4804 7.25 15.5904 7.25H8.40042Z"
          fill="#40B2AA"
        />
        <path
          d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
          fill="#40B2AA"
        />
        <path
          d="M20.41 17.78H8C7.59 17.78 7.25 17.44 7.25 17.03C7.25 16.62 7.59 16.28 8 16.28H20.41C20.82 16.28 21.16 16.62 21.16 17.03C21.16 17.44 20.82 17.78 20.41 17.78Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};

const OrdibeheshtLogo = () => {
  return (
    <>
      <svg
        width="170"
        height="44"
        viewBox="0 0 170 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.243 27.0113H36.2204C36.2053 27.0113 36.1902 27.0113 36.1752 27.0113C36.1601 27.0113 36.145 27.0113 36.13 27.0113C35.5497 27.0264 34.9694 26.9586 34.3891 26.8078C33.3415 26.5064 32.4673 25.9864 31.7665 25.2478C31.0656 24.5093 30.5644 23.6275 30.263 22.6026C29.63 23.2809 28.9291 23.8725 28.1604 24.3774C27.4294 24.8748 26.672 25.3157 25.8882 25.7C25.2401 26.0241 24.5731 26.3029 23.8873 26.5365C22.5233 26.9812 21.1366 27.26 19.7273 27.373C18.3256 27.4936 16.9088 27.4899 15.4769 27.3617C14.2033 27.2788 12.9711 26.9925 11.7804 26.5026C10.5972 26.0052 9.63633 25.2139 8.89778 24.1287C7.94068 22.5386 7.7485 20.858 8.32126 19.087C8.42676 18.7629 8.56618 18.4426 8.73952 18.1261C8.92039 17.802 9.14271 17.527 9.40647 17.3009C9.78329 16.9843 10.2091 16.8826 10.6839 16.9957C11.1662 17.169 11.4978 17.493 11.6786 17.9678C11.8821 18.5104 11.8784 19.053 11.6673 19.5957C11.5317 19.9122 11.3772 20.2249 11.2039 20.5339C11.1737 20.5791 11.1473 20.6281 11.1247 20.6809C10.9363 21.0125 10.7781 21.3554 10.65 21.7096C10.4917 22.2748 10.5633 22.7345 10.8647 23.0887C11.1662 23.4429 11.5694 23.7217 12.0743 23.9252C12.9862 24.2945 13.9282 24.5357 14.9004 24.6487C16.0082 24.7768 17.116 24.8145 18.2239 24.7617C19.2413 24.709 20.2511 24.5884 21.2534 24.4C22.1578 24.2342 23.0357 23.993 23.8873 23.6765C24.7842 23.3374 25.6056 22.9003 26.3517 22.3652C27.1053 21.8301 27.7647 21.1707 28.33 20.387C28.6163 19.9725 28.8839 19.5391 29.1326 19.087C29.3436 18.7026 29.5508 18.3145 29.7543 17.9226C29.7694 17.9 29.7807 17.8774 29.7882 17.8548C29.9691 17.4855 30.2253 17.1841 30.5569 16.9504C30.8131 16.7771 31.0882 16.7319 31.3821 16.8148C31.6534 16.9128 31.8569 17.0861 31.9926 17.3348C32.1357 17.5835 32.2111 17.8472 32.2186 18.1261C32.2413 18.8345 32.2902 19.5429 32.3656 20.2513C32.4259 20.7412 32.5427 21.2348 32.716 21.7322C32.8894 22.222 33.123 22.6742 33.4169 23.0887C33.7108 23.4957 34.0613 23.8272 34.4682 24.0835C34.8752 24.3322 35.3386 24.4565 35.8586 24.4565H36.1978C36.552 24.4716 36.8497 24.5997 37.0908 24.8409C37.332 25.082 37.4526 25.3797 37.4526 25.7339C37.4526 26.073 37.3357 26.3632 37.1021 26.6043C36.876 26.8455 36.5897 26.9774 36.243 27V27.0113ZM17.2065 17.8774C17.832 17.8774 18.3633 18.0959 18.8004 18.533C19.2375 18.9551 19.456 19.4675 19.456 20.0704C19.456 20.6809 19.2375 21.2009 18.8004 21.6304C18.3633 22.06 17.832 22.2748 17.2065 22.2748C16.5885 22.2748 16.0572 22.06 15.6126 21.6304C15.1755 21.2009 14.9569 20.6809 14.9569 20.0704C14.9569 19.4675 15.1755 18.9551 15.6126 18.533C16.0572 18.0959 16.5885 17.8774 17.2065 17.8774ZM21.8413 17.8774C22.4668 17.8774 22.9981 18.0959 23.4352 18.533C23.8723 18.9551 24.0908 19.4675 24.0908 20.0704C24.0908 20.6809 23.8723 21.2009 23.4352 21.6304C22.9981 22.06 22.4668 22.2748 21.8413 22.2748C21.2233 22.2748 20.692 22.06 20.2473 21.6304C19.8102 21.2009 19.5917 20.6809 19.5917 20.0704C19.5917 19.4675 19.8102 18.9551 20.2473 18.533C20.692 18.0959 21.2233 17.8774 21.8413 17.8774ZM40.0149 21.427C39.9094 22.3464 39.7512 23.2168 39.5402 24.0383C39.3367 24.8522 39.0051 25.5304 38.5454 26.073C38.0857 26.6081 37.4187 26.9171 36.5445 27H36.1489C35.7871 26.9849 35.4857 26.8568 35.2445 26.6157C34.9958 26.367 34.8715 26.0693 34.8715 25.7226C34.8715 25.3684 34.9958 25.067 35.2445 24.8183C35.4932 24.5696 35.7946 24.4452 36.1489 24.4452H36.3749C36.8346 24.4452 37.1851 24.2832 37.4262 23.9591C37.6674 23.6275 37.8445 23.2055 37.9575 22.693C38.0781 22.1806 38.1761 21.6304 38.2515 21.0426C38.3268 20.4548 38.4248 19.8933 38.5454 19.3583C38.666 18.8157 38.8544 18.3672 39.1106 18.013C39.3668 17.6513 39.7361 17.4441 40.2184 17.3913C41.3112 17.331 41.9932 18.1374 42.2645 19.8104C42.3173 20.2626 42.3587 20.7487 42.3889 21.2687C42.4265 22.0449 42.517 22.8626 42.6602 23.7217C42.7883 24.287 42.9578 24.5846 43.1689 24.6148C43.4175 24.5922 43.5532 24.2945 43.5758 23.7217C43.606 23.1414 43.572 22.4557 43.4741 21.6643C43.3836 20.873 43.2857 20.142 43.1802 19.4713C43.0219 18.3484 43.086 17.4817 43.3723 16.8713C43.6587 16.2609 44.0355 15.8916 44.5028 15.7635C44.9775 15.6278 45.4109 15.7183 45.8028 16.0348C46.1946 16.3513 46.4132 16.8713 46.4584 17.5948C46.5187 18.1148 46.5564 18.6725 46.5715 19.2678C46.5865 19.8481 46.6242 20.4171 46.6845 20.9748C46.7448 21.5249 46.8616 22.0261 47.0349 22.4783C47.2309 22.9606 47.4946 23.4052 47.8262 23.8122C48.1654 24.2116 48.5874 24.5093 49.0923 24.7052C49.959 24.9916 50.6636 24.9049 51.2062 24.4452C51.7564 23.978 52.088 23.3223 52.201 22.4783C52.3216 21.6267 52.1596 20.7675 51.7149 19.9009C51.2703 19.0342 50.4828 18.3484 49.3523 17.8435C48.9152 17.6928 48.5045 17.6287 48.1202 17.6513C47.8036 17.6588 47.5851 17.6212 47.4645 17.5383C47.1781 17.2368 47.246 16.9843 47.668 16.7809C48.09 16.5774 48.6816 16.4643 49.4428 16.4417C50.2115 16.4191 50.9613 16.5284 51.6923 16.7696C52.2726 16.958 52.8077 17.2067 53.2975 17.5157C53.7949 17.8171 54.217 18.2128 54.5636 18.7026C55.0384 19.411 55.3399 20.1533 55.468 20.9296V20.9183C55.4755 20.9559 55.4831 20.9936 55.4906 21.0313C55.5584 21.6116 55.6489 22.1617 55.7619 22.6817C55.8825 23.1942 56.0633 23.6162 56.3045 23.9478C56.5457 24.2719 56.8999 24.4339 57.3671 24.4339H57.5819C57.9361 24.4339 58.2375 24.5583 58.4862 24.807C58.7349 25.0557 58.8593 25.3571 58.8593 25.7113C58.8593 26.058 58.7349 26.3557 58.4862 26.6043C58.2451 26.8455 57.9436 26.9699 57.5819 26.9774V26.9887L57.1862 27C56.4929 26.9322 55.9315 26.7212 55.5019 26.367C55.0799 26.0052 54.7483 25.538 54.5071 24.9652C54.0625 25.5757 53.4897 26.058 52.7889 26.4122C51.8167 26.8719 50.8219 27.0829 49.8045 27.0452C48.7871 27.0151 47.8677 26.8078 47.0462 26.4235C46.2323 26.0316 45.6407 25.538 45.2715 24.9426C44.9851 25.4928 44.6535 25.8922 44.2767 26.1409C43.9074 26.3896 43.4138 26.5026 42.7958 26.48C42.1025 26.4348 41.5975 26.1446 41.281 25.6096C40.972 25.0745 40.7761 24.449 40.6932 23.733C40.6103 23.0171 40.5651 22.3614 40.5575 21.7661C40.5575 21.7435 40.5575 21.7209 40.5575 21.6983C40.55 21.3968 40.5199 21.1896 40.4671 21.0765C40.4219 20.9559 40.3654 20.907 40.2975 20.9296C40.2297 20.9446 40.1694 21.0012 40.1167 21.0991C40.0639 21.1971 40.03 21.3064 40.0149 21.427ZM48.9228 12.9261C48.9228 13.4988 48.7231 13.9887 48.3236 14.3957C47.9318 14.7951 47.457 14.9948 46.8993 14.9948C46.3416 14.9948 45.8631 14.7951 45.4636 14.3957C45.0718 13.9887 44.8758 13.4988 44.8758 12.9261C44.8758 12.3533 45.0718 11.8672 45.4636 11.4678C45.8631 11.0609 46.3416 10.8574 46.8993 10.8574C47.457 10.8574 47.9318 11.0609 48.3236 11.4678C48.7231 11.8672 48.9228 12.3533 48.9228 12.9261ZM53.0941 12.9374C53.0941 13.5101 52.8944 14 52.4949 14.407C52.1031 14.8064 51.6283 15.0061 51.0706 15.0061C50.5129 15.0061 50.0381 14.8064 49.6462 14.407C49.2544 14 49.0584 13.5101 49.0584 12.9374C49.0584 12.3646 49.2544 11.8786 49.6462 11.4791C50.0381 11.0722 50.5129 10.8687 51.0706 10.8687C51.6283 10.8687 52.1031 11.0722 52.4949 11.4791C52.8944 11.8786 53.0941 12.3646 53.0941 12.9374ZM51.0141 9.20696C51.0141 9.77971 50.8144 10.2696 50.4149 10.6765C50.0231 11.0759 49.5483 11.2757 48.9906 11.2757C48.4329 11.2757 47.9581 11.0759 47.5662 10.6765C47.1744 10.2696 46.9784 9.77971 46.9784 9.20696C46.9784 8.6342 47.1744 8.14812 47.5662 7.74869C47.9581 7.34174 48.4329 7.13826 48.9906 7.13826C49.5483 7.13826 50.0231 7.34174 50.4149 7.74869C50.8144 8.14812 51.0141 8.6342 51.0141 9.20696ZM62.1283 26.7513C61.6761 26.5855 61.2918 26.3557 60.9752 26.0617C60.5306 26.3858 60.0294 26.6232 59.4718 26.7739C58.9216 26.9246 58.4054 27 57.9231 27H57.9004C57.5462 27 57.2448 26.8757 56.9961 26.627C56.7474 26.3783 56.6231 26.0806 56.6231 25.7339C56.6231 25.3797 56.7474 25.0783 56.9961 24.8296C57.2448 24.5733 57.5462 24.4452 57.9004 24.4452C58.3074 24.4452 58.6541 24.3736 58.9404 24.2304C59.2268 24.0797 59.4642 23.88 59.6526 23.6313C59.4868 22.8777 59.4077 22.1165 59.4152 21.3478C59.4303 20.5716 59.4831 19.8707 59.5735 19.2452C59.7468 18.0696 59.7883 17.0183 59.6978 16.0913C59.6526 15.8125 59.566 15.609 59.4378 15.4809C59.3173 15.3452 59.1816 15.2359 59.0309 15.153C58.8952 15.0701 58.7747 14.9797 58.6691 14.8817C58.5712 14.7762 58.5222 14.6142 58.5222 14.3957C58.5222 14.162 58.5787 13.9699 58.6918 13.8191C58.8123 13.6684 58.9555 13.5516 59.1213 13.4687C59.2871 13.3858 59.4529 13.3255 59.6187 13.2878C59.792 13.2501 59.9352 13.2275 60.0483 13.22C60.1613 13.2125 60.2216 13.2087 60.2291 13.2087C62.3393 13.1786 63.9973 13.2803 65.2031 13.5139C66.4089 13.7475 67.2868 14.1997 67.837 14.8704C68.1912 15.3 68.47 15.869 68.6735 16.5774C68.877 17.2783 69.0089 18.0507 69.0691 18.8948C69.0842 19.0907 69.0955 19.2867 69.1031 19.4826C69.1332 19.9423 69.1747 20.4359 69.2274 20.9635C69.2802 21.491 69.3329 21.8867 69.3857 22.1504C69.461 22.5649 69.5891 22.9455 69.77 23.2922C69.9509 23.6388 70.1996 23.9177 70.5161 24.1287C70.8326 24.3397 71.2433 24.4452 71.7483 24.4452C72.0949 24.4452 72.3926 24.5733 72.6413 24.8296C72.8975 25.0783 73.0257 25.3797 73.0257 25.7339C73.0257 26.0806 72.8975 26.3783 72.6413 26.627C72.3926 26.8757 72.0949 27 71.7483 27H71.7144C71.1265 27 70.4897 26.887 69.8039 26.6609C69.1257 26.4272 68.5718 26.0617 68.1422 25.5643C68.0518 25.4513 67.9575 25.3157 67.8596 25.1574C67.6184 25.5342 67.3433 25.8357 67.0344 26.0617C66.4315 26.4762 65.6741 26.7626 64.7622 26.9209C63.8503 27.0791 62.9723 27.0226 62.1283 26.7513ZM61.8118 21.2574L62.0152 21.5965C62.2036 21.8226 62.5352 21.7849 63.01 21.4835C63.4547 21.182 63.9219 20.6922 64.4118 20.0139C64.9091 19.3281 65.2407 18.582 65.4065 17.7757C65.5573 16.7432 65.3802 16.1252 64.8752 15.9217C64.3703 15.7183 63.7297 15.8539 62.9535 16.3287C62.3958 16.6904 62.0115 17.1954 61.8004 17.8435C61.597 18.4841 61.5291 19.1736 61.597 19.9122C61.6196 20.4171 61.6912 20.8655 61.8118 21.2574ZM64.1178 23.5409C63.53 23.8423 63.2889 24.1136 63.3944 24.3548C63.5074 24.5959 63.7825 24.7316 64.2196 24.7617C64.4457 24.7693 64.6755 24.7203 64.9091 24.6148C65.1503 24.5093 65.3764 24.3812 65.5874 24.2304C66.0019 23.9064 66.2544 23.5446 66.3448 23.1452C66.4428 22.7383 66.3825 22.4594 66.1639 22.3087C65.9303 22.5499 65.6251 22.7722 65.2483 22.9757C64.8715 23.1791 64.5173 23.3562 64.1857 23.507C64.1631 23.5145 64.1404 23.5258 64.1178 23.5409ZM79.9166 27C79.9091 27 79.8978 27 79.8827 27C79.8525 27 79.8262 27 79.8035 27H79.7696C79.2873 27 78.7711 26.9246 78.2209 26.7739C77.6708 26.6232 77.1734 26.3896 76.7288 26.073C76.2841 25.749 75.9714 25.3383 75.7905 24.8409C75.5192 25.4362 75.0633 25.9412 74.4227 26.3557C73.7896 26.7626 72.9946 26.9774 72.0375 27H71.9922C71.638 27 71.3366 26.8757 71.0879 26.627C70.8392 26.3783 70.7149 26.0806 70.7149 25.7339C70.7149 25.3797 70.8392 25.082 71.0879 24.8409C71.3291 24.5922 71.6305 24.4641 71.9922 24.4565H72.0262C72.5311 24.4641 73.0285 24.2003 73.5183 23.6652C74.0082 23.1301 74.3473 22.2597 74.5357 21.0539C74.6789 20.0064 74.7731 18.9249 74.8183 17.8096C74.8786 16.9203 75.1009 16.3814 75.4853 16.193C75.8696 15.9971 76.2502 16.0536 76.627 16.3626C77.0038 16.6641 77.2111 17.1162 77.2488 17.7191C77.2563 18.1487 77.2676 18.5594 77.2827 18.9513C77.3053 19.9762 77.3241 20.9484 77.3392 21.8678C77.3467 22.6968 77.5427 23.3223 77.927 23.7443C78.3114 24.1664 78.9293 24.4038 79.7809 24.4565H79.8035C79.8262 24.4565 79.8525 24.4565 79.8827 24.4565C79.9128 24.4565 79.9392 24.4565 79.9618 24.4565C79.9769 24.4565 79.992 24.4565 80.007 24.4565C80.0146 24.4565 80.0221 24.4565 80.0296 24.4565C80.0372 24.4565 80.0409 24.4565 80.0409 24.4565C80.056 24.4565 80.0711 24.4565 80.0862 24.4565C80.9528 24.5093 81.714 24.2342 82.3696 23.6313C83.0328 23.0209 83.3682 22.1203 83.3757 20.9296C83.338 20.1609 83.2551 19.3583 83.127 18.5217C83.0743 18.1374 83.0253 17.7568 82.9801 17.38C82.9122 16.6791 82.9876 16.178 83.2062 15.8765C83.4247 15.5675 83.7035 15.4432 84.0427 15.5035C84.3893 15.5562 84.7134 15.7786 85.0149 16.1704C85.5349 16.9014 85.8853 17.8849 86.0662 19.1209C86.2546 20.3568 86.1943 21.5928 85.8853 22.8287C85.4633 24.2304 84.7096 25.2742 83.6244 25.96C82.5467 26.6383 81.3409 26.9849 80.007 27C79.992 27 79.9769 27 79.9618 27H79.9505C79.9505 27 79.9467 27 79.9392 27C79.9317 27 79.9241 27 79.9166 27ZM72.987 28.2096C73.6125 28.2096 74.1438 28.4243 74.5809 28.8539C75.018 29.2835 75.2366 29.7997 75.2366 30.4026C75.2366 31.013 75.018 31.533 74.5809 31.9626C74.1438 32.3922 73.6125 32.607 72.987 32.607C72.3691 32.607 71.8415 32.3922 71.4044 31.9626C70.9598 31.533 70.7375 31.013 70.7375 30.4026C70.7375 29.7997 70.9598 29.2835 71.4044 28.8539C71.8415 28.4243 72.3691 28.2096 72.987 28.2096ZM80.8209 30.3913C80.8209 31.0168 80.6062 31.5481 80.1766 31.9852C79.747 32.4299 79.2308 32.6522 78.6279 32.6522C78.0175 32.6522 77.4975 32.4299 77.0679 31.9852C76.6383 31.5481 76.4235 31.0168 76.4235 30.3913C76.4235 29.7733 76.6383 29.242 77.0679 28.7974C77.4975 28.3603 78.0175 28.1417 78.6279 28.1417C79.2308 28.1417 79.747 28.3603 80.1766 28.7974C80.6062 29.242 80.8209 29.7733 80.8209 30.3913ZM85.3653 30.4026C85.3653 31.0281 85.1505 31.5594 84.7209 31.9965C84.2914 32.4412 83.7751 32.6635 83.1722 32.6635C82.5618 32.6635 82.0418 32.4412 81.6122 31.9965C81.1827 31.5594 80.9679 31.0281 80.9679 30.4026C80.9679 29.7846 81.1827 29.2533 81.6122 28.8087C82.0418 28.3716 82.5618 28.153 83.1722 28.153C83.7751 28.153 84.2914 28.3716 84.7209 28.8087C85.1505 29.2533 85.3653 29.7846 85.3653 30.4026ZM92.6555 20.8391C92.2787 20.5829 91.6607 20.1081 90.8016 19.4148C89.95 18.7139 89.1474 17.9904 88.3938 17.2443C87.6477 16.4907 87.2407 15.8991 87.1729 15.4696C87.1653 15.0099 87.3726 14.6368 87.7946 14.3504C88.2242 14.0641 88.7932 13.9812 89.5016 14.1017C89.7352 14.1545 89.9424 14.2638 90.1233 14.4296C90.3117 14.5954 90.5001 14.7875 90.6885 15.0061C90.8091 15.1493 90.941 15.2962 91.0842 15.447C91.5891 15.967 92.1619 16.6038 92.8024 17.3574C93.4506 18.111 94.0082 18.8081 94.4755 19.4487C94.8975 19.9913 95.1387 20.4699 95.199 20.8843C95.2668 21.2913 95.0897 21.8038 94.6677 22.4217C94.1778 23.1678 93.688 23.9441 93.1981 24.7504C92.7384 25.5116 92.2674 26.2614 91.7851 27C91.7474 27.0603 91.7097 27.1206 91.672 27.1809C91.25 27.8516 90.8393 28.4168 90.4398 28.8765C90.0404 29.3362 89.6259 29.5472 89.1964 29.5096C88.7442 29.4568 88.3485 29.2797 88.0094 28.9783C87.6778 28.6768 87.5723 28.2133 87.6929 27.5878C87.8135 26.9623 88.3335 26.1409 89.2529 25.1235C89.4714 24.8823 89.8143 24.4754 90.2816 23.9026C90.7564 23.3299 91.2236 22.7496 91.6833 22.1617C92.143 21.5664 92.4671 21.1255 92.6555 20.8391ZM99.9121 20.1383C99.8217 20.7788 99.6634 21.5588 99.4373 22.4783C99.2188 23.3977 98.9814 24.302 98.7252 25.1913C98.3107 26.7136 97.7681 28.0551 97.0973 29.2157C96.4266 30.3838 95.5449 31.1713 94.4521 31.5783C93.8718 31.7667 93.4272 31.7177 93.1182 31.4313C92.8092 31.1525 92.7037 30.6664 92.8017 29.973C92.8921 29.2797 93.2539 28.4168 93.8869 27.3843C94.7988 25.9901 95.5373 24.6261 96.1026 23.2922C96.6753 21.9507 97.184 20.647 97.6287 19.3809C97.8095 18.8533 97.9979 18.3333 98.1939 17.8209C98.631 16.6829 99.0342 15.9858 99.4034 15.7296C99.7727 15.4658 100.044 15.5487 100.217 15.9783C100.398 16.4003 100.428 17.0786 100.308 18.013C100.255 18.307 100.187 18.6612 100.104 19.0757C100.082 19.2113 100.055 19.3432 100.025 19.4713C99.98 19.7426 99.9423 19.9649 99.9121 20.1383ZM105.328 23.7104C105.049 25.1649 104.695 26.1446 104.266 26.6496C103.836 27.147 103.456 27.1093 103.124 26.5365C102.8 25.9562 102.645 24.773 102.66 22.987C102.66 22.9643 102.66 22.9417 102.66 22.9191C102.668 22.5574 102.676 22.1881 102.683 21.8113C102.706 20.1609 102.747 18.5104 102.807 16.86C102.823 16.3475 102.823 15.8238 102.807 15.2887C102.777 14.4899 102.792 13.7965 102.853 13.2087C102.958 12.6209 103.214 12.2441 103.621 12.0783C104.036 11.9049 104.454 12.0217 104.876 12.4287C105.298 12.8357 105.577 13.6081 105.713 14.7461C105.848 16.4417 105.852 18.1299 105.724 19.8104C105.634 21.4006 105.502 22.7006 105.328 23.7104Z"
          fill="#8D6650"
        />
        <path
          d="M117.986 7.6344H125.856C135.785 7.6344 143.848 15.6649 143.848 25.5542V33.3914C143.848 35.0272 142.505 36.3656 140.862 36.3656H132.993C123.063 36.3656 115 28.3351 115 18.4458V10.6086C115 8.97281 116.344 7.6344 117.986 7.6344Z"
          fill="#91A371"
        />
        <path
          d="M151.612 33.8301H147.342C146.52 33.8301 145.849 33.1609 145.849 32.3429V28.0898C145.849 18.2004 153.912 10.1699 163.842 10.1699H168.112C168.933 10.1699 169.605 10.8392 169.605 11.6571V15.9102C169.605 25.7996 161.542 33.8301 151.612 33.8301Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};

const SortIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
          fill="#40B2AA"
        />
        <path
          d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
          fill="#40B2AA"
        />
        <path
          d="M14 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H14C14.41 16.25 14.75 16.59 14.75 17C14.75 17.41 14.41 17.75 14 17.75Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};

const ArrowSquareLeft = () => {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 13.55V15.5C2.5 20.5 4.5 22.5 9.5 22.5H15.5C20.5 22.5 22.5 20.5 22.5 15.5V9.5C22.5 4.5 20.5 2.5 15.5 2.5H9.5C4.5 2.5 2.5 4.5 2.5 9.5"
          stroke="#A38471"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.7602 16.03L10.2402 12.5L13.7602 8.96997"
          stroke="#A38471"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const WhatsApp = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27811)">
          <path
            d="M12.1521 24C18.8613 24 24.3002 18.6274 24.3002 12C24.3002 5.37258 18.8613 0 12.1521 0C5.44282 0 0.00390625 5.37258 0.00390625 12C0.00390625 18.6274 5.44282 24 12.1521 24Z"
            fill="white"
          />
          <path
            d="M17.0988 7.11681C16.3945 6.94281 15.3587 6.34187 14.6882 6.10098C12.0704 5.2929 8.55276 5.93935 7.57109 8.92928C7.48928 9.01009 7.32566 9.01009 7.24385 9.01009C5.2805 11.2727 6.58941 14.0202 6.42579 16.5252C6.36994 17.4083 5.89986 18.1892 5.29492 18.8497L10.3859 23.8733C10.9626 23.9562 11.5522 24 12.1522 24C18.1521 24 23.1355 19.7032 24.1223 14.0549L17.0988 7.11681Z"
            fill="#E1E3D6"
          />
          <path
            d="M11.8128 5.08345C8.11006 5.25745 5.1881 8.30358 5.19925 11.9652C5.20267 13.0805 5.47524 14.1331 5.95614 15.0634L5.2179 18.6031C5.17799 18.7947 5.35281 18.9623 5.54538 18.9172L9.05672 18.0955C9.95886 18.5395 10.9721 18.7958 12.0445 18.812C15.8291 18.8691 18.9846 15.9008 19.1028 12.1637C19.2291 8.15789 15.8822 4.89197 11.8128 5.08345ZM16.0027 15.747C14.9744 16.7627 13.6071 17.3222 12.1527 17.3222C11.3012 17.3222 10.4859 17.1334 9.72947 16.7613L9.2406 16.5206L7.08762 17.0244L7.54076 14.8515L7.29993 14.3854C6.9072 13.6257 6.70809 12.8044 6.70809 11.9439C6.70809 10.5073 7.27445 9.1568 8.30272 8.14097C9.32184 7.13419 10.7114 6.56578 12.1528 6.56578C13.607 6.56578 14.9743 7.12523 16.0026 8.14097C17.0309 9.1567 17.5972 10.5074 17.5972 11.9438C17.5973 13.3677 17.0218 14.7403 16.0027 15.747Z"
            fill="#40B2AA"
          />
          <path
            d="M15.5265 13.4335L14.1796 13.0515C14.0026 13.0014 13.8118 13.051 13.6828 13.1809L13.3534 13.5123C13.2145 13.6522 13.0038 13.697 12.82 13.6236C12.1828 13.3688 10.8425 12.1916 10.5004 11.603C10.4015 11.4331 10.4179 11.2208 10.5392 11.0657L10.8267 10.6982C10.9393 10.5543 10.963 10.3609 10.8886 10.1945L10.3219 8.92847C10.1862 8.62528 9.79398 8.53697 9.53768 8.7511C9.1618 9.06521 8.71578 9.54235 8.66164 10.0711C8.56602 11.0033 8.9708 12.1783 10.501 13.5893C12.269 15.2195 13.6849 15.4347 14.6069 15.2142C15.1298 15.0892 15.5476 14.5877 15.8112 14.177C15.9911 13.8968 15.8489 13.525 15.5265 13.4335Z"
            fill="#40B2AA"
          />
          <path
            d="M16.8971 6.92383L15.8425 7.99155C15.8962 8.04053 15.9496 8.0898 16.0015 8.14113C17.0299 9.15686 17.5962 10.5075 17.5962 11.944C17.5962 13.3678 17.0207 14.7403 16.0015 15.7471C14.9733 16.7628 13.6059 17.3223 12.1516 17.3223C11.3001 17.3223 10.4848 17.1335 9.72835 16.7614L9.23948 16.5207L7.0865 17.0245L7.13101 16.8111L5.22461 18.741C5.26665 18.8658 5.40043 18.9508 5.54416 18.9172L9.0555 18.0955C9.95764 18.5394 10.9709 18.7957 12.0433 18.8119C15.8279 18.869 18.9835 15.9007 19.1015 12.1637C19.1668 10.0949 18.3056 8.22353 16.8971 6.92383Z"
            fill="#40B2AA"
          />
          <path
            d="M15.527 13.4336L14.18 13.0516C14.0031 13.0015 13.8123 13.0511 13.6833 13.181L13.3539 13.5124C13.215 13.6523 13.0043 13.6971 12.8205 13.6237C12.4524 13.4765 11.85 13.0216 11.3407 12.55L10.4043 13.4981C10.4364 13.5285 10.4685 13.5588 10.5016 13.5894C12.2696 15.2196 13.6854 15.4348 14.6074 15.2143C15.1303 15.0893 15.5482 14.5878 15.8117 14.1771C15.9916 13.897 15.8494 13.5251 15.527 13.4336Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27811">
            <rect
              width="24.2963"
              height="24"
              fill="white"
              transform="translate(0.00390625)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const Spotify = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27732)">
          <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="white"
          />
          <path
            d="M18.6244 9.70697L11.2852 8.78784L5.41406 9.7778L8.25591 12.0808L6.21713 12.5981L8.39062 14.6667L6.81422 15.3733L15.0495 23.6086C19.3213 22.4895 22.6637 19.0751 23.6799 14.7625L18.6244 9.70697Z"
            fill="#E1E3D6"
          />
          <path
            d="M15.9697 16.0624C15.8488 16.2694 15.6312 16.3848 15.4076 16.3848C15.2962 16.3848 15.1832 16.3561 15.08 16.2958C13.3708 15.297 11.3962 15.1364 10.0405 15.1777C8.5387 15.2233 7.43737 15.5198 7.42645 15.5229C7.08028 15.6175 6.72252 15.4137 6.62751 15.0677C6.53254 14.7216 6.73565 14.364 7.08163 14.2687C7.13123 14.2551 8.31646 13.9332 9.96445 13.8788C10.9352 13.8468 11.8697 13.9144 12.7417 14.0799C13.8462 14.2894 14.8537 14.6572 15.7363 15.1729C16.0465 15.354 16.151 15.7523 15.9697 16.0624ZM17.1789 13.5511C17.0357 13.7962 16.7778 13.9329 16.513 13.9329C16.381 13.9329 16.2472 13.8989 16.125 13.8275C14.1005 12.6443 11.7615 12.4542 10.1556 12.503C8.3766 12.5572 7.07203 12.9084 7.05913 12.9119C6.64912 13.0238 6.22527 12.7827 6.11277 12.3726C6.00027 11.9626 6.24084 11.5392 6.65071 11.4262C6.70954 11.4101 8.11335 11.0287 10.0655 10.9643C11.2155 10.9264 12.3224 11.0065 13.3553 11.2024C14.6636 11.4507 15.857 11.8863 16.9024 12.4972C17.2699 12.7119 17.3937 13.1837 17.1789 13.5511ZM17.9222 11.2676C17.7603 11.2676 17.5963 11.226 17.4463 11.1383C12.6331 8.32549 6.38953 9.99771 6.32709 10.0149C5.82388 10.1536 5.30367 9.85807 5.16506 9.35487C5.0264 8.85167 5.3219 8.33145 5.8251 8.19284C5.8972 8.17296 7.6191 7.70525 10.0137 7.62631C11.4243 7.57985 12.7821 7.6781 14.049 7.91843C15.6538 8.22284 17.1177 8.75712 18.3999 9.50656C18.8505 9.7699 19.0024 10.3487 18.739 10.7992C18.5633 11.1 18.2471 11.2676 17.9222 11.2676Z"
            fill="#40B2AA"
          />
          <path
            d="M15.0803 16.2959C15.1834 16.3562 15.2963 16.3849 15.4079 16.3849C15.6315 16.3849 15.8491 16.2695 15.97 16.0625C16.1513 15.7524 16.0468 15.3541 15.7366 15.1728C14.8541 14.657 13.8465 14.2893 12.7421 14.0798C12.3059 13.997 11.8541 13.9388 11.39 13.9052L11.2852 15.2032C12.4655 15.2889 13.8424 15.5724 15.0803 16.2959Z"
            fill="#40B2AA"
          />
          <path
            d="M18.3997 9.50673C17.1174 8.75729 15.6535 8.22301 14.0488 7.91861C13.356 7.78721 12.6352 7.69984 11.8943 7.65381L11.7422 9.53729C13.5705 9.64637 15.612 10.0667 17.446 11.1385C17.5959 11.2261 17.76 11.2678 17.922 11.2678C18.2468 11.2678 18.5631 11.1001 18.7387 10.7994C19.0021 10.3487 18.8503 9.77007 18.3997 9.50673Z"
            fill="#40B2AA"
          />
          <path
            d="M16.1258 13.8276C16.248 13.8991 16.3818 13.933 16.5138 13.933C16.7786 13.933 17.0365 13.7964 17.1797 13.5512C17.3944 13.1838 17.2707 12.712 16.9033 12.4974C15.8579 11.8865 14.6645 11.4509 13.3562 11.2027C12.7996 11.0971 12.2208 11.0263 11.6261 10.9884L11.502 12.5246C12.9279 12.6146 14.6144 12.9443 16.1258 13.8276Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27732">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const BrownTwitterIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0076 6.49288L18.9704 6.46808C18.2014 5.73634 17.2961 5.38907 16.2543 5.43868L16.2171 5.36426L16.2419 5.35186C17.1844 5.14102 17.7426 4.91778 17.9162 4.66973C17.9658 4.47129 17.9038 4.35967 17.6929 4.33486C17.2217 4.39688 16.7752 4.4961 16.3907 4.65733C16.8868 4.33486 17.0728 4.11162 16.9612 4C16.4775 4.0124 15.9442 4.26045 15.3985 4.75655C15.5969 4.40928 15.6838 4.21084 15.6341 4.18604C15.3613 4.35967 15.138 4.55811 14.9396 4.76895C14.5179 5.24024 14.1831 5.67432 13.9226 6.0712L13.9102 6.09601C13.2529 7.17501 12.7816 8.25402 12.5087 9.35784L12.4095 9.44465L12.3847 9.45706C11.9878 8.96096 11.5041 8.53928 10.9336 8.20441C10.2639 7.75793 9.47015 7.34865 8.55237 6.93937C7.56018 6.41847 6.54318 5.99679 5.52619 5.66192C5.51378 6.81535 6.08429 7.72072 7.18811 8.39045V8.40285C6.80363 8.40285 6.41916 8.46486 6.04709 8.57649C6.1215 9.64309 6.87805 10.3748 8.30432 10.7717L8.29192 10.7965C7.73381 10.7593 7.27492 10.9577 6.91526 11.367C7.38655 12.2848 8.21751 12.7189 9.42054 12.6941C9.18489 12.8181 8.99886 12.9421 8.87484 13.091C8.65159 13.3266 8.57718 13.5995 8.65159 13.9095C8.91204 14.3808 9.37093 14.5917 10.0531 14.5544L10.0903 14.6041L10.0779 14.6289C8.89964 15.8443 7.47336 16.39 5.81144 16.2784L5.78664 16.2908C4.76964 16.2784 3.67823 15.7947 2.5 14.8273C3.67823 16.5264 5.25333 17.7543 7.20051 18.5356C9.42054 19.2674 11.653 19.3294 13.873 18.6968H13.9102C16.0682 18.0767 17.8914 16.7869 19.4045 14.8521C20.099 13.8475 20.5331 12.8801 20.7067 11.9499C21.8353 11.9871 22.6415 11.6647 23.15 10.9701L23.1376 10.9453C22.7531 11.0818 22.0214 11.0446 20.9424 10.8213V10.6973C22.133 10.5609 22.8399 10.1764 23.0632 9.54387C22.2322 9.86634 21.4137 9.87874 20.6075 9.56868C20.4587 8.45246 19.9254 7.42306 19.0076 6.49288Z"
          fill="#C2D1D9"
        />
        <mask
          id="mask0_120_25002"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="2"
          y="4"
          width="22"
          height="16"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0076 6.49288L18.9704 6.46808C18.2014 5.73634 17.2961 5.38907 16.2543 5.43868L16.2171 5.36426L16.2419 5.35186C17.1844 5.14102 17.7426 4.91778 17.9162 4.66973C17.9658 4.47129 17.9038 4.35967 17.6929 4.33486C17.2217 4.39688 16.7752 4.4961 16.3907 4.65733C16.8868 4.33486 17.0728 4.11162 16.9612 4C16.4775 4.0124 15.9442 4.26045 15.3985 4.75655C15.5969 4.40928 15.6838 4.21084 15.6341 4.18604C15.3613 4.35967 15.138 4.55811 14.9396 4.76895C14.5179 5.24024 14.1831 5.67432 13.9226 6.0712L13.9102 6.09601C13.2529 7.17501 12.7816 8.25402 12.5087 9.35784L12.4095 9.44465L12.3847 9.45706C11.9878 8.96096 11.5041 8.53928 10.9336 8.20441C10.2639 7.75793 9.47015 7.34865 8.55237 6.93937C7.56018 6.41847 6.54318 5.99679 5.52619 5.66192C5.51378 6.81535 6.08429 7.72072 7.18811 8.39045V8.40285C6.80363 8.40285 6.41916 8.46486 6.04709 8.57649C6.1215 9.64309 6.87805 10.3748 8.30432 10.7717L8.29192 10.7965C7.73381 10.7593 7.27492 10.9577 6.91526 11.367C7.38655 12.2848 8.21751 12.7189 9.42054 12.6941C9.18489 12.8181 8.99886 12.9421 8.87484 13.091C8.65159 13.3266 8.57718 13.5995 8.65159 13.9095C8.91204 14.3808 9.37093 14.5917 10.0531 14.5544L10.0903 14.6041L10.0779 14.6289C8.89964 15.8443 7.47336 16.39 5.81144 16.2784L5.78664 16.2908C4.76964 16.2784 3.67823 15.7947 2.5 14.8273C3.67823 16.5264 5.25333 17.7543 7.20051 18.5356C9.42054 19.2674 11.653 19.3294 13.873 18.6968H13.9102C16.0682 18.0767 17.8914 16.7869 19.4045 14.8521C20.099 13.8475 20.5331 12.8801 20.7067 11.9499C21.8353 11.9871 22.6415 11.6647 23.15 10.9701L23.1376 10.9453C22.7531 11.0818 22.0214 11.0446 20.9424 10.8213V10.6973C22.133 10.5609 22.8399 10.1764 23.0632 9.54387C22.2322 9.86634 21.4137 9.87874 20.6075 9.56868C20.4587 8.45246 19.9254 7.42306 19.0076 6.49288Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_120_25002)">
          <rect x="0.5" width="24" height="24" fill="#8D6650" />
        </g>
      </svg>
    </>
  );
};

const GreenTwitterIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27767)">
          <path
            d="M12.2969 24C18.9243 24 24.2969 18.6274 24.2969 12C24.2969 5.37258 18.9243 0 12.2969 0C5.66946 0 0.296875 5.37258 0.296875 12C0.296875 18.6274 5.66946 24 12.2969 24Z"
            fill="white"
          />
          <path
            d="M18.7191 6.53088C17.4674 7.61693 16.2228 8.56877 15.2056 9.89895C12.7034 12.9164 9.64561 17.1974 5.48438 16.5592L12.9192 23.984C19.2218 23.6619 24.2394 18.4766 24.2951 12.107L18.7191 6.53088Z"
            fill="#E1E3D6"
          />
          <path
            d="M18.9468 7.61586C18.6415 7.75128 18.3247 7.85806 17.9995 7.93531C18.3578 7.59495 18.6272 7.16909 18.7791 6.69387C18.8225 6.55826 18.6751 6.44084 18.5526 6.5135C18.1003 6.78186 17.6131 6.983 17.1045 7.11172C17.075 7.11922 17.0446 7.12296 17.014 7.12296C16.9213 7.12296 16.8314 7.08861 16.7604 7.02617C16.2194 6.54926 15.5234 6.28662 14.8008 6.28662C14.488 6.28662 14.1724 6.33537 13.8625 6.43151C12.9022 6.72931 12.1612 7.52154 11.9286 8.49884C11.8414 8.86531 11.8179 9.23234 11.8585 9.58934C11.863 9.6304 11.8438 9.659 11.8318 9.6724C11.8107 9.69593 11.781 9.70948 11.75 9.70948C11.7466 9.70948 11.743 9.70934 11.7395 9.70901C9.63737 9.51364 7.74169 8.50095 6.40191 6.85728C6.33371 6.77342 6.20255 6.78373 6.14808 6.87706C5.88577 7.32734 5.74711 7.84217 5.74711 8.36609C5.74711 9.16892 6.0698 9.92562 6.6301 10.4773C6.39446 10.4214 6.16637 10.3334 5.95444 10.2156C5.85188 10.1587 5.72583 10.232 5.72438 10.3493C5.70985 11.542 6.40819 12.6034 7.4543 13.0812C7.43321 13.0817 7.41211 13.0819 7.39102 13.0819C7.22522 13.0819 7.05722 13.0661 6.89204 13.0343C6.77658 13.0124 6.6796 13.1218 6.71541 13.2337C7.05507 14.2939 7.96777 15.0753 9.06015 15.2526C8.15363 15.8612 7.09782 16.1821 5.99911 16.1821L5.65665 16.182C5.55094 16.182 5.46165 16.2508 5.43493 16.3531C5.40844 16.4536 5.45715 16.5599 5.54724 16.6123C6.7853 17.3329 8.1976 17.7136 9.63183 17.7136C10.8873 17.7136 12.0617 17.4646 13.1224 16.9731C14.0948 16.5227 14.9541 15.8788 15.6765 15.0593C16.3494 14.2959 16.8756 13.4147 17.2404 12.44C17.5882 11.5111 17.772 10.5197 17.772 9.5734V9.52822C17.772 9.37629 17.8407 9.23332 17.9606 9.13587C18.4156 8.7664 18.8119 8.33159 19.1382 7.84343C19.2245 7.71462 19.0885 7.553 18.9468 7.61586Z"
            fill="#40B2AA"
          />
          <path
            d="M18.9468 7.61586C18.6414 7.75128 18.3247 7.85806 17.9995 7.93531C18.3578 7.59495 18.6272 7.16909 18.7792 6.69387C18.8226 6.55826 18.6751 6.44084 18.5527 6.5135C18.1003 6.78186 17.6131 6.983 17.1045 7.11172C17.0751 7.11922 17.0447 7.12296 17.0141 7.12296C16.9213 7.12296 16.8315 7.08861 16.7604 7.02617C16.2194 6.54926 15.5234 6.28662 14.8008 6.28662C14.4881 6.28662 14.1725 6.33537 13.8626 6.43151C13.1912 6.63968 12.6278 7.09001 12.2695 7.67586V17.3076C12.5612 17.2125 12.8458 17.1012 13.1226 16.9729C14.095 16.5225 14.9543 15.8787 15.6766 15.0592C16.3496 14.2957 16.8757 13.4146 17.2406 12.4399C17.5883 11.511 17.7721 10.5195 17.7721 9.57326V9.52807C17.7721 9.37615 17.8408 9.23318 17.9608 9.13573C18.4157 8.76626 18.812 8.33145 19.1384 7.84329C19.2245 7.71462 19.0885 7.553 18.9468 7.61586Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27767">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.296875)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const Viber = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27787)">
          <path
            d="M12.0039 24C18.6313 24 24.0039 18.6274 24.0039 12C24.0039 5.37258 18.6313 0 12.0039 0C5.37649 0 0.00390625 5.37258 0.00390625 12C0.00390625 18.6274 5.37649 24 12.0039 24Z"
            fill="white"
          />
          <path
            d="M17.2096 6.58325C14.2887 5.87778 11.3626 5.05259 8.36723 6.101C6.42782 6.82826 6.42782 8.9293 6.50863 10.7071C6.50863 11.1919 5.94299 11.8384 6.18538 12.404C6.67021 14.0202 7.07427 15.6364 8.77124 16.4444C9.01368 16.6061 8.77124 16.9293 8.93287 17.1717C8.85205 17.1717 8.69043 17.2525 8.69043 17.3333C8.69043 17.7207 8.86424 18.3131 8.74879 18.695L13.9053 23.8494C19.2064 23.0052 23.3496 18.69 23.9325 13.3062L17.2096 6.58325Z"
            fill="#E1E3D6"
          />
          <path
            d="M18.3528 8.43395L18.3489 8.41811C18.0282 7.12187 16.5827 5.731 15.2552 5.44164L15.2403 5.43854C13.0931 5.02895 10.916 5.02895 8.7693 5.43854L8.75388 5.44164C7.42684 5.731 5.98127 7.12196 5.66022 8.41811L5.65666 8.43395C5.26028 10.2441 5.26028 12.0799 5.65666 13.8901L5.66022 13.9059C5.96763 15.1468 7.30549 16.4739 8.58344 16.8388V18.2857C8.58344 18.8094 9.22164 19.0667 9.58455 18.6887L11.0506 17.1648C11.3686 17.1826 11.6867 17.1925 12.0048 17.1925C13.0855 17.1925 14.1669 17.0903 15.2402 16.8856L15.2552 16.8825C16.5827 16.5931 18.0282 15.2021 18.3488 13.906L18.3527 13.8902C18.7491 12.0799 18.7491 10.2442 18.3528 8.43395ZM17.1926 13.6277C16.9785 14.4733 15.881 15.5246 15.0089 15.7189C13.8673 15.936 12.7165 16.0288 11.567 15.9969C11.5441 15.9963 11.5221 16.0052 11.5062 16.0216C11.3431 16.189 10.4358 17.1204 10.4358 17.1204L9.29734 18.2889C9.21409 18.3758 9.06784 18.3167 9.06784 18.1969V15.7999C9.06784 15.7603 9.03958 15.7267 9.00067 15.719C9.00044 15.7189 9.00025 15.7189 9.00002 15.7188C8.12795 15.5246 7.0308 14.4733 6.81634 13.6276C6.45958 11.9914 6.45958 10.3327 6.81634 8.69645C7.0308 7.85078 8.12795 6.79946 9.00002 6.60521C10.9939 6.226 13.0155 6.226 15.009 6.60521C15.8815 6.79946 16.9786 7.85078 17.1926 8.69645C17.5498 10.3327 17.5498 11.9914 17.1926 13.6277Z"
            fill="#40B2AA"
          />
          <path
            d="M13.9018 14.7341C13.7677 14.6933 13.64 14.666 13.5213 14.6168C12.2917 14.1067 11.1601 13.4486 10.2638 12.4398C9.75411 11.8661 9.35516 11.2184 9.01794 10.533C8.858 10.208 8.72323 9.87026 8.58584 9.53463C8.46059 9.22863 8.64509 8.91251 8.83934 8.68188C9.02164 8.46546 9.25625 8.2999 9.51031 8.17779C9.70859 8.08254 9.90416 8.13748 10.049 8.30552C10.362 8.6689 10.6497 9.05084 10.8824 9.47205C11.0256 9.73113 10.9864 10.0478 10.7268 10.2241C10.6637 10.267 10.6062 10.3173 10.5475 10.3657C10.496 10.4081 10.4475 10.4509 10.4121 10.5084C10.3476 10.6134 10.3445 10.7374 10.386 10.8516C10.706 11.7311 11.2454 12.415 12.1307 12.7834C12.2723 12.8423 12.4145 12.9109 12.5778 12.8919C12.851 12.8599 12.9395 12.5601 13.1311 12.4035C13.3182 12.2505 13.5575 12.2485 13.7591 12.3761C13.9608 12.5037 14.1563 12.6407 14.3506 12.7792C14.5414 12.9152 14.7313 13.0481 14.9072 13.2031C15.0764 13.3521 15.1347 13.5476 15.0394 13.7497C14.865 14.1201 14.6112 14.4281 14.2452 14.6248C14.1418 14.6802 14.0183 14.6981 13.9018 14.7341C14.0183 14.6981 13.7677 14.6933 13.9018 14.7341Z"
            fill="#40B2AA"
          />
          <path
            d="M12.0086 7.7543C13.6168 7.79939 14.9378 8.86669 15.2209 10.4567C15.2691 10.7276 15.2863 11.0046 15.3077 11.2796C15.3168 11.3952 15.2513 11.5051 15.1265 11.5066C14.9976 11.5082 14.9396 11.4003 14.9311 11.2847C14.9146 11.0559 14.9031 10.826 14.8716 10.5991C14.7051 9.40102 13.7498 8.40984 12.5573 8.19717C12.3778 8.16516 12.1943 8.15677 12.0124 8.13769C11.8975 8.12564 11.7471 8.1187 11.7216 7.97583C11.7003 7.85606 11.8013 7.76072 11.9154 7.75458C11.9463 7.75275 11.9775 7.7542 12.0086 7.7543C13.6169 7.79939 11.9775 7.7542 12.0086 7.7543Z"
            fill="#40B2AA"
          />
          <path
            d="M14.4523 10.9228C14.4496 10.9429 14.4483 10.9901 14.4365 11.0345C14.3938 11.1959 14.1489 11.2161 14.0926 11.0533C14.0759 11.0049 14.0734 10.9499 14.0733 10.8979C14.0728 10.5573 13.9987 10.217 13.8269 9.92057C13.6504 9.61593 13.3805 9.35995 13.0642 9.20493C12.8728 9.11127 12.666 9.05301 12.4563 9.01837C12.3646 9.00318 12.272 8.99404 12.1799 8.9812C12.0683 8.96568 12.0087 8.89457 12.014 8.7846C12.0189 8.68157 12.0943 8.60737 12.2066 8.61379C12.5756 8.6347 12.9321 8.71457 13.2603 8.88829C13.9275 9.24168 14.3087 9.7994 14.42 10.5442C14.425 10.578 14.4331 10.6114 14.4357 10.6452C14.4419 10.7287 14.4459 10.8124 14.4523 10.9228C14.4496 10.9428 14.4459 10.8124 14.4523 10.9228Z"
            fill="#40B2AA"
          />
          <path
            d="M13.4518 10.8838C13.3173 10.8862 13.2453 10.8117 13.2313 10.6884C13.2217 10.6025 13.214 10.5153 13.1935 10.4316C13.1531 10.2667 13.0655 10.114 12.9268 10.013C12.8614 9.96529 12.7872 9.93055 12.7095 9.90805C12.6108 9.8795 12.5083 9.88738 12.4099 9.86329C12.303 9.83708 12.2438 9.75046 12.2606 9.65019C12.2759 9.55888 12.3647 9.48763 12.4645 9.49489C13.088 9.53989 13.5337 9.86225 13.5973 10.5963C13.6018 10.6481 13.6071 10.7028 13.5956 10.7525C13.5758 10.8372 13.513 10.8797 13.4518 10.8838C13.513 10.8797 13.3172 10.8862 13.4518 10.8838Z"
            fill="#40B2AA"
          />
          <path
            d="M18.3515 8.43391L18.3476 8.41807C18.1678 7.69146 17.6345 6.93518 16.9667 6.35974L16.064 7.1598C16.6008 7.58754 17.0607 8.18008 17.1914 8.69637C17.5486 10.3326 17.5486 11.9913 17.1914 13.6276C16.9773 14.4733 15.8797 15.5246 15.0077 15.7189C13.8661 15.936 12.7153 16.0287 11.5658 15.9969C11.5429 15.9963 11.5209 16.0052 11.505 16.0216C11.3419 16.189 10.4346 17.1204 10.4346 17.1204L9.29614 18.2889C9.21289 18.3757 9.06664 18.3167 9.06664 18.1969V15.7999C9.06664 15.7602 9.03838 15.7266 8.99947 15.7189C8.99923 15.7189 8.99905 15.7189 8.99881 15.7189C8.5032 15.6085 7.93512 15.2211 7.4975 14.7522L6.60547 15.5427C7.16258 16.1487 7.88112 16.6387 8.58209 16.8388V18.2858C8.58209 18.8095 9.2203 19.0667 9.5832 18.6888L11.0492 17.1649C11.3672 17.1827 11.6853 17.1926 12.0034 17.1926C13.0842 17.1926 14.1655 17.0904 15.2389 16.8856L15.2538 16.8826C16.5813 16.5932 18.0268 15.2023 18.3475 13.9061L18.3514 13.8903C18.7478 12.0799 18.7478 10.2442 18.3515 8.43391Z"
            fill="#40B2AA"
          />
          <path
            d="M13.9 14.7341C13.766 14.6934 14.0165 14.6982 13.9 14.7341V14.7341Z"
            fill="white"
          />
          <path
            d="M14.9058 13.203C14.7299 13.0481 14.5399 12.9151 14.3492 12.7792C14.1549 12.6406 13.9594 12.5037 13.7577 12.376C13.5561 12.2484 13.3169 12.2504 13.1297 12.4035C12.9382 12.5601 12.8497 12.8599 12.5764 12.8918C12.4132 12.9108 12.2709 12.8422 12.1293 12.7833C11.5846 12.5567 11.1714 12.2102 10.8591 11.7727L10.1953 12.361C10.2179 12.3871 10.2394 12.4139 10.2623 12.4397C11.1586 13.4485 12.2903 14.1066 13.5197 14.6168C13.6384 14.666 13.7662 14.6933 13.9003 14.734C13.7662 14.6933 14.0169 14.6981 13.9003 14.734C14.0169 14.6981 14.1403 14.6801 14.2437 14.6247C14.6099 14.428 14.8636 14.1199 15.038 13.7496C15.1333 13.5475 15.075 13.352 14.9058 13.203Z"
            fill="#40B2AA"
          />
          <path
            d="M12.0123 7.7547C12.0109 7.7547 12.0096 7.75455 12.0083 7.75455C12.0069 7.75446 12.0086 7.75455 12.0123 7.7547Z"
            fill="white"
          />
          <path
            d="M12.0078 7.75439C12.0092 7.75439 12.0105 7.75454 12.0118 7.75454C12.1011 7.75772 13.5527 7.79771 12.0078 7.75439Z"
            fill="white"
          />
          <path
            d="M14.3142 8.71106L14.0312 8.96189C14.476 9.39454 14.7826 9.96797 14.8703 10.599C14.9018 10.826 14.9133 11.0558 14.9299 11.2846C14.9383 11.4003 14.9962 11.5081 15.1252 11.5066C15.25 11.5051 15.3155 11.3953 15.3065 11.2796C15.285 11.0046 15.2679 10.7276 15.2196 10.4567C15.0957 9.76068 14.7729 9.16486 14.3142 8.71106Z"
            fill="#40B2AA"
          />
          <path
            d="M14.4194 10.5439C14.3383 10.0012 14.1132 9.55835 13.7392 9.22095L13.457 9.47103C13.603 9.60054 13.7292 9.75265 13.8264 9.92042C13.9982 10.2168 14.0722 10.5571 14.0728 10.8977C14.0729 10.9497 14.0754 11.0048 14.0921 11.0532C14.1485 11.2162 14.3933 11.196 14.4359 11.0344C14.4477 10.9899 14.4491 10.9427 14.4518 10.9227C14.4453 10.8124 14.4491 10.9428 14.4518 10.9227C14.4453 10.8124 14.4414 10.7287 14.435 10.6451C14.4325 10.6111 14.4244 10.5777 14.4194 10.5439Z"
            fill="#40B2AA"
          />
          <path
            d="M14.4508 10.9228C14.4444 10.8125 14.4481 10.9428 14.4508 10.9228V10.9228Z"
            fill="white"
          />
          <path
            d="M13.4508 10.8839C13.4529 10.8838 13.4549 10.8827 13.4569 10.8824C13.4513 10.8824 13.4425 10.8826 13.4336 10.8829C13.4394 10.8831 13.4447 10.8839 13.4508 10.8839Z"
            fill="white"
          />
          <path
            d="M13.4506 10.8839C13.4446 10.884 13.4392 10.8831 13.4334 10.8829C13.4043 10.8837 13.3743 10.8853 13.4506 10.8839Z"
            fill="white"
          />
          <path
            d="M13.4573 10.8824C13.4552 10.8827 13.4532 10.8838 13.4512 10.8839C13.4669 10.8828 13.4656 10.8824 13.4573 10.8824Z"
            fill="white"
          />
          <path
            d="M13.1662 9.72778L12.8789 9.98241C12.8947 9.99202 12.9103 10.002 12.9253 10.013C13.064 10.114 13.1516 10.2667 13.192 10.4316C13.2125 10.5153 13.2201 10.6024 13.2298 10.6884C13.2431 10.8062 13.31 10.8787 13.4331 10.8829C13.442 10.8826 13.4508 10.8825 13.4564 10.8824C13.5157 10.8758 13.575 10.8343 13.594 10.7524C13.6055 10.7028 13.6003 10.648 13.5957 10.5962C13.56 10.1858 13.4048 9.90427 13.1662 9.72778Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27787">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.00390625)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const Telegram = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27740)">
          <path
            d="M12.1481 24C18.8574 24 24.2963 18.6274 24.2963 12C24.2963 5.37258 18.8574 0 12.1481 0C5.43891 0 0 5.37258 0 12C0 18.6274 5.43891 24 12.1481 24Z"
            fill="white"
          />
          <path
            d="M24.292 11.7224L18.8993 6.4043L10.1152 16.9807L16.4401 23.2284C21.0306 21.5151 24.2956 17.1345 24.2956 12C24.2956 11.9071 24.2941 11.8146 24.292 11.7224Z"
            fill="#E1E3D6"
          />
          <path
            d="M18.2096 6.25881C18.6939 6.07215 19.1946 6.49074 19.0882 6.99334L16.9163 17.2487C16.8148 17.7295 16.243 17.9461 15.8421 17.6551L12.5634 15.2778L10.8921 16.9635C10.5984 17.2592 10.092 17.1388 9.96604 16.7445L8.76024 12.9634L5.52808 12.0204C5.10351 11.8967 5.07897 11.3133 5.49044 11.1541L18.2096 6.25881ZM16.6152 8.53435C16.7567 8.4107 16.5923 8.19254 16.4319 8.29112L9.45553 12.565C9.33282 12.6402 9.2764 12.7881 9.31972 12.9246L10.2711 17.0515C10.29 17.1145 10.3815 17.1056 10.3898 17.0402L10.6024 13.8952C10.6106 13.8176 10.6482 13.7465 10.7072 13.6948L16.6152 8.53435Z"
            fill="#40B2AA"
          />
          <path
            d="M16.4314 8.29109C16.5917 8.19252 16.7561 8.41067 16.6146 8.53433L10.7066 13.6947C10.6477 13.7465 10.6101 13.8176 10.6019 13.8951L10.3892 17.0402C10.3811 17.1056 10.2894 17.1145 10.2706 17.0515L9.31918 12.9246C9.27581 12.788 9.33228 12.6402 9.455 12.565L16.4314 8.29109Z"
            fill="#C59C00"
          />
          <path
            d="M10.3055 17.0943C10.1517 17.0401 10.0217 16.9189 9.96604 16.7444L8.76024 12.9633L5.52808 12.0203C5.10351 11.8966 5.07897 11.3132 5.49044 11.1541L18.2096 6.25876C18.522 6.13834 18.8419 6.27005 18.9998 6.51413C18.9703 6.4697 18.9352 6.42849 18.8959 6.39212L10.267 13.3505V13.6551L10.2196 13.6212L10.267 15.5396V17.0782C10.2793 17.0838 10.2924 17.0887 10.3055 17.0927V17.0943H10.3055Z"
            fill="#40B2AA"
          />
          <path
            d="M19.1007 6.82118C19.1031 6.87612 19.099 6.93429 19.0867 6.99331L16.9148 17.2487C16.8133 17.7295 16.2415 17.946 15.8407 17.6551L12.5619 15.2778L10.2656 13.6551V13.3505L18.8945 6.39209C18.9338 6.42846 18.969 6.46967 18.9984 6.51411C19.0041 6.52381 19.0098 6.53267 19.0156 6.54157C19.0205 6.55128 19.0262 6.56098 19.0311 6.56984C19.036 6.57954 19.041 6.58925 19.045 6.59895C19.0499 6.60945 19.0541 6.61915 19.0581 6.62965C19.0614 6.63856 19.0655 6.64821 19.0688 6.65876C19.0794 6.69026 19.0876 6.72261 19.0933 6.75654C19.0966 6.77754 19.099 6.79859 19.1007 6.82118Z"
            fill="#40B2AA"
          />
          <path
            d="M12.5619 15.2777L10.8906 16.9634C10.8767 16.9771 10.862 16.9909 10.8472 17.003C10.8325 17.0152 10.8177 17.0257 10.8022 17.0362C10.8014 17.0369 10.8014 17.0369 10.8014 17.0369C10.7703 17.0572 10.7385 17.0741 10.7049 17.0879C10.6877 17.0943 10.6714 17.1008 10.6542 17.1048C10.583 17.1258 10.5102 17.1315 10.4382 17.1242C10.4194 17.1226 10.4006 17.1194 10.3826 17.1162C10.3801 17.1162 10.3777 17.1154 10.3752 17.1146C10.3573 17.1097 10.3392 17.1049 10.3212 17.0992C10.3155 17.0976 10.3098 17.096 10.3041 17.0927L10.2656 15.5396V13.6552L12.5619 15.2777Z"
            fill="#40B2AA"
          />
          <path
            d="M10.8477 17.0029C10.833 17.0151 10.8183 17.0264 10.8027 17.0369V17.0361C10.8183 17.0256 10.833 17.0151 10.8477 17.0029Z"
            fill="#40B2AA"
          />
          <path
            d="M10.707 17.0878C10.7406 17.074 10.7725 17.0571 10.8036 17.0369C10.7725 17.057 10.7397 17.074 10.707 17.0878Z"
            fill="#40B2AA"
          />
          <path
            d="M10.4395 17.1241C10.5114 17.1314 10.5842 17.1257 10.6554 17.1047C10.6039 17.1209 10.5507 17.1282 10.4975 17.1282C10.4812 17.1282 10.4648 17.1274 10.4493 17.1257C10.446 17.1258 10.4427 17.1258 10.4395 17.1241Z"
            fill="#40B2AA"
          />
          <path
            d="M10.4396 17.1241C10.4429 17.1257 10.4462 17.1257 10.4495 17.1257C10.4323 17.1249 10.4167 17.1225 10.4004 17.1193C10.4134 17.1217 10.4265 17.1233 10.4396 17.1241Z"
            fill="#40B2AA"
          />
          <path
            d="M10.4384 17.1242C10.4253 17.1234 10.4122 17.1217 10.3992 17.1193C10.3934 17.1185 10.3877 17.1177 10.3828 17.1161C10.4008 17.1193 10.4196 17.1226 10.4384 17.1242Z"
            fill="#40B2AA"
          />
          <path
            d="M10.3223 17.0991C10.3403 17.1048 10.3583 17.1096 10.3763 17.1145C10.3689 17.1129 10.3616 17.1113 10.3542 17.1097C10.3509 17.1089 10.3477 17.1081 10.3452 17.1064C10.3378 17.1048 10.3296 17.1024 10.3223 17.0991Z"
            fill="#40B2AA"
          />
          <path
            d="M10.3535 17.1096C10.3609 17.1112 10.3682 17.1129 10.3756 17.1144C10.3682 17.1137 10.3609 17.1121 10.3535 17.1096Z"
            fill="#40B2AA"
          />
          <path
            d="M10.3225 17.0991C10.3299 17.1024 10.3381 17.1048 10.3454 17.1064C10.3331 17.104 10.3209 17.0999 10.3086 17.0951C10.3135 17.0967 10.3176 17.0983 10.3225 17.0991Z"
            fill="#40B2AA"
          />
          <path
            d="M10.3219 17.0992C10.317 17.0984 10.3128 17.0968 10.308 17.0952C10.3072 17.096 10.3055 17.0952 10.3047 17.0944V17.0928C10.3104 17.096 10.3161 17.0976 10.3219 17.0992Z"
            fill="#40B2AA"
          />
          <path
            d="M10.2656 15.5396L10.3041 17.0927C10.291 17.0886 10.2779 17.0838 10.2656 17.0781V15.5396Z"
            fill="#40B2AA"
          />
          <path
            d="M10.2662 13.6552V15.5396L10.2188 13.6212L10.2662 13.6552Z"
            fill="#40B2AA"
          />
          <path
            d="M16.6146 8.5343L10.7066 13.6947C10.6477 13.7464 10.6101 13.8175 10.6019 13.8951L10.3896 17.0404C10.3814 17.1059 10.2898 17.1148 10.2702 17.0517L9.31918 12.9246C9.27581 12.7881 9.33228 12.6402 9.455 12.565L16.4314 8.29111C16.5917 8.19249 16.7562 8.41069 16.6146 8.5343Z"
            fill="#336BB8"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27740">
            <rect width="24.2963" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const GreenLinkdin = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27782)">
          <path
            d="M12.0039 23.9999C18.6313 23.9999 24.0038 18.6273 24.0038 12C24.0038 5.37256 18.6313 0 12.0039 0C5.37647 0 0.00390625 5.37256 0.00390625 12C0.00390625 18.6273 5.37647 23.9999 12.0039 23.9999Z"
            fill="white"
          />
          <path
            d="M23.9586 10.9516L18.5077 5.49365C15.1779 5.92664 11.6982 5.86204 8.36843 5.93948C6.99471 5.93948 5.62095 6.58593 5.86339 8.12127C6.34822 11.1919 6.59065 14.1819 6.02501 17.3333C5.93595 17.7339 5.74859 18.1344 5.50391 18.508L10.9492 23.9533C11.297 23.9836 11.649 24 12.0047 24C18.6321 24 24.0047 18.6274 24.0047 12C24.0048 11.6466 23.9886 11.2971 23.9586 10.9516Z"
            fill="#E1E3D6"
          />
          <path
            d="M17.6294 5.13135H6.37742C5.69103 5.13135 5.13477 5.68761 5.13477 6.374V17.6259C5.13477 18.3121 5.69103 18.8686 6.37742 18.8686H17.6293C18.3155 18.8686 18.872 18.3121 18.872 17.6259V6.374C18.8721 5.68761 18.3156 5.13135 17.6294 5.13135ZM9.38565 16.993C9.38565 17.1928 9.2238 17.3547 9.02397 17.3547H7.48474C7.28491 17.3547 7.12305 17.1927 7.12305 16.993V10.5401C7.12305 10.3403 7.28501 10.1785 7.48474 10.1785H9.02406C9.22389 10.1785 9.38575 10.3404 9.38575 10.5401V16.993H9.38565ZM8.25433 9.57011C7.44668 9.57011 6.79202 8.91532 6.79202 8.10757C6.79202 7.29996 7.44663 6.64526 8.25433 6.64526C9.06208 6.64526 9.71673 7.30006 9.71673 8.10757C9.71673 8.91541 9.06203 9.57011 8.25433 9.57011ZM17.4302 17.0221C17.4302 17.2058 17.2814 17.3548 17.0979 17.3548H15.4459C15.2624 17.3548 15.1135 17.2058 15.1135 17.0221V13.9952C15.1135 13.5438 15.2459 12.0166 13.9335 12.0166C12.9155 12.0166 12.709 13.062 12.6675 13.5309V17.022C12.6675 17.2057 12.5187 17.3547 12.335 17.3547H10.7374C10.5538 17.3547 10.4048 17.2057 10.4048 17.022V10.511C10.4048 10.3273 10.5537 10.1784 10.7374 10.1784H12.335C12.5187 10.1784 12.6675 10.3273 12.6675 10.511V11.0739C13.0451 10.5074 13.6061 10.07 14.8004 10.07C17.4454 10.07 17.4304 12.5411 17.4304 13.899V17.0222H17.4302V17.0221Z"
            fill="#40B2AA"
          />
          <path
            d="M17.6295 5.13135H11.9766V10.1784H12.335C12.5187 10.1784 12.6675 10.3273 12.6675 10.511V11.0739C13.0451 10.5074 13.6061 10.07 14.8005 10.07C17.4454 10.07 17.4304 12.5411 17.4304 13.899V17.0221C17.4304 17.2057 17.2816 17.3547 17.0981 17.3547H15.4461C15.2626 17.3547 15.1137 17.2058 15.1137 17.0221V13.9952C15.1137 13.5438 15.2461 12.0166 13.9337 12.0166C12.9157 12.0166 12.7092 13.0619 12.6677 13.5308V17.022C12.6677 17.2056 12.5189 17.3546 12.3352 17.3546H11.9767V18.8687H17.6297C18.3159 18.8687 18.8723 18.3123 18.8723 17.6261V6.374C18.8721 5.68761 18.3157 5.13135 17.6295 5.13135Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27782">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.00390625)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const Setting = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.75 5C22.75 5.41 22.41 5.75 22 5.75L11 5.75C10.59 5.75 10.25 5.41 10.25 5C10.25 4.59 10.59 4.25 11 4.25L22 4.25C22.41 4.25 22.75 4.59 22.75 5Z"
          fill="#40B2AA"
        />
        <path
          d="M7.75 5C7.75 5.41 7.41 5.75 7 5.75L2 5.75C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25L7 4.25C7.41 4.25 7.75 4.59 7.75 5Z"
          fill="#40B2AA"
        />
        <path
          d="M22.75 12C22.75 12.41 22.41 12.75 22 12.75L17 12.75C16.59 12.75 16.25 12.41 16.25 12C16.25 11.59 16.59 11.25 17 11.25L22 11.25C22.41 11.25 22.75 11.59 22.75 12Z"
          fill="#40B2AA"
        />
        <path
          d="M13.75 12C13.75 12.41 13.41 12.75 13 12.75L2 12.75C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25L13 11.25C13.41 11.25 13.75 11.59 13.75 12Z"
          fill="#40B2AA"
        />
        <path
          d="M22.75 19C22.75 19.41 22.41 19.75 22 19.75L11 19.75C10.59 19.75 10.25 19.41 10.25 19C10.25 18.59 10.59 18.25 11 18.25L22 18.25C22.41 18.25 22.75 18.59 22.75 19Z"
          fill="#40B2AA"
        />
        <path
          d="M7.75 19C7.75 19.41 7.41 19.75 7 19.75L2 19.75C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25L7 18.25C7.41 18.25 7.75 18.59 7.75 19Z"
          fill="#40B2AA"
        />
        <path
          d="M11.75 17L11.75 21C11.75 21.41 11.41 21.75 11 21.75C10.59 21.75 10.25 21.41 10.25 21L10.25 17C10.25 16.59 10.59 16.25 11 16.25C11.41 16.25 11.75 16.59 11.75 17Z"
          fill="#40B2AA"
        />
        <path
          d="M11.75 3L11.75 7C11.75 7.41 11.41 7.75 11 7.75C10.59 7.75 10.25 7.41 10.25 7L10.25 3C10.25 2.59 10.59 2.25 11 2.25C11.41 2.25 11.75 2.59 11.75 3Z"
          fill="#40B2AA"
        />
        <path
          d="M13.75 10L13.75 14C13.75 14.41 13.41 14.75 13 14.75C12.59 14.75 12.25 14.41 12.25 14L12.25 10C12.25 9.59 12.59 9.25 13 9.25C13.41 9.25 13.75 9.59 13.75 10Z"
          fill="#40B2AA"
        />
      </svg>
    </>
  );
};

const BrownInstagram = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4995 16.2941V10.563V7.70541C19.4995 6.21314 18.2859 5 16.7936 5H8.20541C6.71314 5 5.5 6.21314 5.5 7.70541V10.563V16.2941C5.5 17.7869 6.71314 19 8.20541 19H16.7941C18.2859 19 19.4995 17.7869 19.4995 16.2941ZM14.9642 11.9993C14.9642 13.3582 13.8572 14.4632 12.4993 14.4632C11.1409 14.4632 10.0348 13.3577 10.0363 11.9988C10.0368 11.4623 10.2108 10.9671 10.5023 10.5625C10.951 9.94182 11.6783 9.53529 12.5007 9.53529C13.3227 9.53529 14.0505 9.94231 14.4982 10.563C14.7887 10.9676 14.9642 11.4628 14.9642 11.9993ZM17.8798 8.98499V6.91961V6.61224L17.571 6.61323L15.5066 6.61967L15.5145 8.99292L17.8798 8.98499ZM12.4998 15.8281C14.6112 15.8281 16.3286 14.1097 16.3286 11.9993C16.3286 11.4916 16.2259 11.0062 16.044 10.563H18.1347V16.2941C18.1347 17.0348 17.5323 17.6347 16.7931 17.6347H8.20491C7.46473 17.6347 6.86336 17.0348 6.86336 16.2941V10.563H8.95303C8.77257 11.0062 8.67143 11.4916 8.67143 11.9993C8.67143 14.1097 10.3883 15.8281 12.4998 15.8281Z"
          fill="#8D6650"
        />
        <mask
          id="mask0_120_25012"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="5"
          y="5"
          width="15"
          height="14"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.4995 16.2941V10.563V7.70541C19.4995 6.21314 18.2859 5 16.7936 5H8.20541C6.71314 5 5.5 6.21314 5.5 7.70541V10.563V16.2941C5.5 17.7869 6.71314 19 8.20541 19H16.7941C18.2859 19 19.4995 17.7869 19.4995 16.2941ZM14.9642 11.9993C14.9642 13.3582 13.8572 14.4632 12.4993 14.4632C11.1409 14.4632 10.0348 13.3577 10.0363 11.9988C10.0368 11.4623 10.2108 10.9671 10.5023 10.5625C10.951 9.94182 11.6783 9.53529 12.5007 9.53529C13.3227 9.53529 14.0505 9.94231 14.4982 10.563C14.7887 10.9676 14.9642 11.4628 14.9642 11.9993ZM17.8798 8.98499V6.91961V6.61224L17.571 6.61323L15.5066 6.61967L15.5145 8.99292L17.8798 8.98499ZM12.4998 15.8281C14.6112 15.8281 16.3286 14.1097 16.3286 11.9993C16.3286 11.4916 16.2259 11.0062 16.044 10.563H18.1347V16.2941C18.1347 17.0348 17.5323 17.6347 16.7931 17.6347H8.20491C7.46473 17.6347 6.86336 17.0348 6.86336 16.2941V10.563H8.95303C8.77257 11.0062 8.67143 11.4916 8.67143 11.9993C8.67143 14.1097 10.3883 15.8281 12.4998 15.8281Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_120_25012)">
          <rect x="0.5" width="24" height="24" fill="#8D6650" />
        </g>
      </svg>
    </>
  );
};

const GreenInstagram = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27772)">
          <path
            d="M12.1505 24C18.6971 24 24.0042 18.6274 24.0042 12C24.0042 5.37258 18.6971 0 12.1505 0C5.60394 0 0.296875 5.37258 0.296875 12C0.296875 18.6274 5.60394 24 12.1505 24Z"
            fill="white"
          />
          <path
            d="M17.6465 6.23075C16.2302 6.41225 14.7535 6.40592 13.2673 6.26267C11.1919 6.10105 8.15868 5.13135 7.04115 7.07075C5.24587 10.1756 6.13133 14.1505 6.54968 17.6682L12.7885 23.9826C18.8259 23.6581 23.6645 18.7604 23.986 12.6487L17.6465 6.23075Z"
            fill="#E1E3D6"
          />
          <path
            d="M14.8926 5.13135H9.4077C7.17866 5.13135 5.36523 6.96716 5.36523 9.22372V14.7763C5.36523 17.0328 7.17866 18.8687 9.40775 18.8687H14.8926C17.1216 18.8687 18.9351 17.0329 18.9351 14.7763V9.22372C18.9351 6.96716 17.1216 5.13135 14.8926 5.13135ZM17.57 14.7763C17.57 16.2733 16.3713 17.4868 14.8926 17.4868H9.40775C7.9291 17.4868 6.7304 16.2733 6.7304 14.7763V9.22377C6.7304 7.72686 7.9291 6.51332 9.40775 6.51332H14.8926C16.3713 6.51332 17.57 7.72691 17.57 9.22377V14.7763Z"
            fill="#40B2AA"
          />
          <path
            d="M12.1503 8.44702C10.2151 8.44702 8.64062 10.041 8.64062 12.0001C8.64062 13.959 10.2151 15.5529 12.1503 15.5529C14.0855 15.5529 15.6599 13.9591 15.6599 12.0001C15.6599 10.041 14.0855 8.44702 12.1503 8.44702ZM12.1503 14.171C10.9659 14.171 10.0057 13.1991 10.0057 12.0001C10.0057 10.801 10.9659 9.82899 12.1503 9.82899C13.3347 9.82899 14.2948 10.8009 14.2948 12.0001C14.2948 13.1991 13.3347 14.171 12.1503 14.171Z"
            fill="#40B2AA"
          />
          <path
            d="M16.5062 8.47383C16.5062 8.94398 16.1297 9.32522 15.6652 9.32522C15.2008 9.32522 14.8242 8.94398 14.8242 8.47383C14.8242 8.00362 15.2008 7.62244 15.6652 7.62244C16.1298 7.62244 16.5062 8.00353 16.5062 8.47383Z"
            fill="#40B2AA"
          />
          <path
            d="M14.8921 5.13135H12.123V6.51332H14.8921C16.3707 6.51332 17.5694 7.72691 17.5694 9.22377V14.7763C17.5694 16.2733 16.3707 17.4868 14.8921 17.4868H12.123V18.8687H14.8921C17.121 18.8687 18.9345 17.0329 18.9345 14.7763V9.22372C18.9345 6.96716 17.1211 5.13135 14.8921 5.13135Z"
            fill="#40B2AA"
          />
          <path
            d="M12.1496 8.44702C12.1407 8.44702 12.132 8.44768 12.123 8.44768V9.82965C12.1319 9.82955 12.1407 9.82899 12.1496 9.82899C13.334 9.82899 14.2941 10.8009 14.2941 12.0001C14.2941 13.1991 13.3341 14.171 12.1496 14.171C12.1407 14.171 12.1319 14.1704 12.123 14.1703V15.5523C12.132 15.5524 12.1407 15.5529 12.1496 15.5529C14.0848 15.5529 15.6592 13.9591 15.6592 12.0001C15.6592 10.041 14.0848 8.44702 12.1496 8.44702Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27772">
            <rect
              width="23.7073"
              height="24"
              fill="white"
              transform="translate(0.296875)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const HeartIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.59 5.83665C21.47 6.82665 22 8.12665 22 9.55665C22 16.5567 15.52 20.6867 12.62 21.6867C12.28 21.8067 11.72 21.8067 11.38 21.6867C8.48 20.6867 2 16.5567 2 9.55665C2 6.46665 4.49 3.96665 7.56 3.96665C9.38 3.96665 10.99 4.84665 12 6.20665C13.01 4.84665 14.63 3.96665 16.44 3.96665"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const GreenYoutube = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_190_27820)">
          <path
            d="M12.3008 24C18.9282 24 24.3008 18.6274 24.3008 12C24.3008 5.37258 18.9282 0 12.3008 0C5.67336 0 0.300781 5.37258 0.300781 12C0.300781 18.6274 5.67336 24 12.3008 24Z"
            fill="white"
          />
          <path
            d="M18.3419 7.98462C17.9821 8.09445 17.6068 8.18881 17.231 8.28279C14.5644 8.84843 11.0088 7.31309 9.47345 9.81813C8.19297 11.81 7.78867 14.3026 6.33203 16.0836L14.1125 23.864C19.2908 23.0803 23.3831 18.9874 24.166 13.8088L18.3419 7.98462Z"
            fill="#E1E3D6"
          />
          <path
            d="M16.3156 7.14062H8.28603C6.71066 7.14062 5.43359 8.41773 5.43359 9.99306V14.0071C5.43359 15.5824 6.7107 16.8595 8.28603 16.8595H16.3156C17.891 16.8595 19.1681 15.5824 19.1681 14.0071V9.99306C19.1681 8.41773 17.891 7.14062 16.3156 7.14062ZM14.3865 12.1953L10.6309 13.9865C10.5307 14.0343 10.4151 13.9614 10.4151 13.8505V10.1561C10.4151 10.0436 10.5338 9.97075 10.634 10.0216L14.3896 11.9248C14.5015 11.9814 14.4995 12.1415 14.3865 12.1953Z"
            fill="#40B2AA"
          />
          <path
            d="M16.3163 7.14062H12.2207V10.8252L14.3904 11.9247C14.5022 11.9813 14.5001 12.1414 14.3872 12.1953L12.2207 13.2286V16.8595H16.3163C17.8917 16.8595 19.1688 15.5824 19.1688 14.0071V9.99306C19.1688 8.41773 17.8916 7.14062 16.3163 7.14062Z"
            fill="#40B2AA"
          />
        </g>
        <defs>
          <clipPath id="clip0_190_27820">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.300781)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const ShareIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 15.8667V8.86667"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 22.8667C7.04493 22.8667 8.5 21.4116 8.5 19.6167C8.5 17.8218 7.04493 16.3667 5.25 16.3667C3.45507 16.3667 2 17.8218 2 19.6167C2 21.4116 3.45507 22.8667 5.25 22.8667Z"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 8.86667C6.65685 8.86667 8 7.52352 8 5.86667C8 4.20982 6.65685 2.86667 5 2.86667C3.34315 2.86667 2 4.20982 2 5.86667C2 7.52352 3.34315 8.86667 5 8.86667Z"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 8.86667C20.6569 8.86667 22 7.52352 22 5.86667C22 4.20982 20.6569 2.86667 19 2.86667C17.3431 2.86667 16 4.20982 16 5.86667C16 7.52352 17.3431 8.86667 19 8.86667Z"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.13086 15.8667C5.58086 14.1167 7.18086 12.8167 9.07086 12.8267L12.5009 12.8367C13.3509 12.8367 14.1709 12.6667 14.9009 12.3467"
          stroke="#B9B9B9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const BrownCircleProfile = () => {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#8D6650" />
        <path
          d="M20.1205 21.5299C20.1005 21.5299 20.0705 21.5299 20.0505 21.5299C20.0205 21.5299 19.9805 21.5299 19.9505 21.5299C17.6805 21.4599 15.9805 19.6899 15.9805 17.5099C15.9805 15.2899 17.7905 13.4799 20.0105 13.4799C22.2305 13.4799 24.0405 15.2899 24.0405 17.5099C24.0305 19.6999 22.3205 21.4599 20.1505 21.5299C20.1305 21.5299 20.1305 21.5299 20.1205 21.5299ZM20.0005 14.9699C18.6005 14.9699 17.4705 16.1099 17.4705 17.4999C17.4705 18.8699 18.5405 19.9799 19.9005 20.0299C19.9305 20.0199 20.0305 20.0199 20.1305 20.0299C21.4705 19.9599 22.5205 18.8599 22.5305 17.4999C22.5305 16.1099 21.4005 14.9699 20.0005 14.9699Z"
          fill="#FBF9F7"
        />
        <path
          d="M20.0008 30.75C17.3108 30.75 14.7408 29.75 12.7508 27.93C12.5708 27.77 12.4908 27.53 12.5108 27.3C12.6408 26.11 13.3808 25 14.6108 24.18C17.5908 22.2 22.4208 22.2 25.3908 24.18C26.6208 25.01 27.3608 26.11 27.4908 27.3C27.5208 27.54 27.4308 27.77 27.2508 27.93C25.2608 29.75 22.6908 30.75 20.0008 30.75ZM14.0808 27.1C15.7408 28.49 17.8308 29.25 20.0008 29.25C22.1708 29.25 24.2608 28.49 25.9208 27.1C25.7408 26.49 25.2608 25.9 24.5508 25.42C22.0908 23.78 17.9208 23.78 15.4408 25.42C14.7308 25.9 14.2608 26.49 14.0808 27.1Z"
          fill="#FBF9F7"
        />
        <path
          d="M20 30.7499C14.07 30.7499 9.25 25.9299 9.25 19.9999C9.25 14.0699 14.07 9.24994 20 9.24994C25.93 9.24994 30.75 14.0699 30.75 19.9999C30.75 25.9299 25.93 30.7499 20 30.7499ZM20 10.7499C14.9 10.7499 10.75 14.8999 10.75 19.9999C10.75 25.0999 14.9 29.2499 20 29.2499C25.1 29.2499 29.25 25.0999 29.25 19.9999C29.25 14.8999 25.1 10.7499 20 10.7499Z"
          fill="#FBF9F7"
        />
      </svg>
    </>
  );
};

const OrderListIcon = () => {
  return (
    <>
      <svg
        width="8"
        height="9"
        viewBox="0 0 8 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="3.99902" cy="4.86667" r="4" fill="#40B2AA" />
      </svg>
    </>
  );
};

const CloseSquare = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.64097 12.9834C7.48264 12.9834 7.32432 12.925 7.19932 12.8C6.95765 12.5584 6.95765 12.1584 7.19932 11.9167L11.916 7.20005C12.1577 6.95838 12.5577 6.95838 12.7993 7.20005C13.041 7.44172 13.041 7.84172 12.7993 8.08338L8.08264 12.8C7.96597 12.925 7.79931 12.9834 7.64097 12.9834Z"
          fill="#B9B9B9"
        />
        <path
          d="M12.3577 12.9834C12.1993 12.9834 12.041 12.925 11.916 12.8L7.19932 8.08338C6.95765 7.84172 6.95765 7.44172 7.19932 7.20005C7.44097 6.95838 7.84097 6.95838 8.08264 7.20005L12.7993 11.9167C13.041 12.1584 13.041 12.5584 12.7993 12.8C12.6743 12.925 12.516 12.9834 12.3577 12.9834Z"
          fill="#B9B9B9"
        />
        <path
          d="M12.4998 18.9583H7.49984C2.97484 18.9583 1.0415 17.025 1.0415 12.5V7.49996C1.0415 2.97496 2.97484 1.04163 7.49984 1.04163H12.4998C17.0248 1.04163 18.9582 2.97496 18.9582 7.49996V12.5C18.9582 17.025 17.0248 18.9583 12.4998 18.9583ZM7.49984 2.29163C3.65817 2.29163 2.2915 3.65829 2.2915 7.49996V12.5C2.2915 16.3416 3.65817 17.7083 7.49984 17.7083H12.4998C16.3415 17.7083 17.7082 16.3416 17.7082 12.5V7.49996C17.7082 3.65829 16.3415 2.29163 12.4998 2.29163H7.49984Z"
          fill="#B9B9B9"
        />
      </svg>
    </>
  );
};

const BrownFacebook = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7525 12.0056H13.7901C13.7901 15.1408 13.7901 19 13.7901 19H10.8823C10.8823 19 10.8823 15.1782 10.8823 12.0056H9.5V9.53354H10.8823V7.93458C10.8823 6.78942 11.4264 5 13.8168 5L15.9716 5.00826V7.40791C15.9716 7.40791 14.6622 7.40791 14.4077 7.40791C14.1531 7.40791 13.7911 7.53521 13.7911 8.08131V9.53403H16.0066L15.7525 12.0056Z"
          fill="#C2D1D9"
        />
        <mask
          id="mask0_120_25007"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="9"
          y="5"
          width="8"
          height="14"
        >
          <path
            d="M15.7525 12.0056H13.7901C13.7901 15.1408 13.7901 19 13.7901 19H10.8823C10.8823 19 10.8823 15.1782 10.8823 12.0056H9.5V9.53354H10.8823V7.93458C10.8823 6.78942 11.4264 5 13.8168 5L15.9716 5.00826V7.40791C15.9716 7.40791 14.6622 7.40791 14.4077 7.40791C14.1531 7.40791 13.7911 7.53521 13.7911 8.08131V9.53403H16.0066L15.7525 12.0056Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_120_25007)">
          <rect x="0.5" width="24" height="24" fill="#8D6650" />
        </g>
      </svg>
    </>
  );
};

const BrownSwitchIcon = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="15" fill="#A38471" />
        <path
          d="M23.3333 10.4167H18.3333"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0001 10.4167H6.66675"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.2501 10.4167C16.2501 12.025 14.9417 13.3333 13.3334 13.3333C11.7251 13.3333 10.4167 12.025 10.4167 10.4167C10.4167 8.80833 11.7251 7.5 13.3334 7.5C13.6167 7.5 13.8917 7.54167 14.1501 7.61667"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.3333 19.5833H20"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6667 19.5833H6.66675"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.6667 22.5C18.2775 22.5 19.5833 21.1942 19.5833 19.5833C19.5833 17.9725 18.2775 16.6667 16.6667 16.6667C15.0558 16.6667 13.75 17.9725 13.75 19.5833C13.75 21.1942 15.0558 22.5 16.6667 22.5Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const Location = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.711 7.30287C10.711 8.5212 9.72646 9.51287 8.50104 9.51287C7.27563 9.51287 6.29102 8.52828 6.29102 7.30287C6.29102 6.07748 7.28271 5.0929 8.50104 5.0929C8.74188 5.0929 8.97563 5.12831 9.18813 5.19915"
          stroke="#B9A193"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.2365 3.04588C7.33189 0.134627 13.3315 1.13338 14.4365 6.02796C15.2511 9.62632 13.0127 12.6722 11.0506 14.5563C9.62689 15.9305 7.37439 15.9305 5.94358 14.5563C3.98858 12.6651 1.74317 9.61924 2.56483 6.02088"
          stroke="#B9A193"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const MedalStar = () => {
  return (
    <>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M47.5 22.5C47.5 26.125 46.425 29.45 44.575 32.225C41.875 36.225 37.6 39.05 32.625 39.775C31.775 39.925 30.9 40 30 40C29.1 40 28.225 39.925 27.375 39.775C22.4 39.05 18.125 36.225 15.425 32.225C13.575 29.45 12.5 26.125 12.5 22.5C12.5 12.825 20.325 5 30 5C39.675 5 47.5 12.825 47.5 22.5Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M53.1228 46.1748L48.9978 47.1498C48.0728 47.3748 47.3478 48.0748 47.1478 48.9998L46.2728 52.6748C45.7978 54.6748 43.2478 55.2748 41.9228 53.6998L29.9978 39.9998L18.0728 53.7248C16.7478 55.2998 14.1978 54.6998 13.7228 52.6998L12.8478 49.0248C12.6228 48.0998 11.8978 47.3748 10.9978 47.1748L6.87276 46.1998C4.97276 45.7498 4.29776 43.3748 5.67276 41.9998L15.4228 32.2498C18.1228 36.2498 22.3978 39.0748 27.3728 39.7998C28.2228 39.9498 29.0978 40.0248 29.9978 40.0248C30.8978 40.0248 31.7728 39.9498 32.6228 39.7998C37.5978 39.0748 41.8728 36.2498 44.5728 32.2498L54.3228 41.9998C55.6978 43.3498 55.0228 45.7248 53.1228 46.1748Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M31.45 14.95L32.925 17.9C33.125 18.3 33.65 18.7 34.125 18.775L36.8 19.225C38.5 19.5 38.9 20.75 37.675 21.975L35.6 24.05C35.25 24.4 35.05 25.075 35.175 25.575L35.775 28.15C36.25 30.175 35.175 30.975 33.375 29.9L30.875 28.425C30.425 28.15 29.675 28.15 29.225 28.425L26.725 29.9C24.9249 30.95 23.8499 30.175 24.3249 28.15L24.9249 25.575C25.025 25.1 24.8499 24.4 24.4999 24.05L22.4249 21.975C21.1999 20.75 21.5999 19.525 23.2999 19.225L25.975 18.775C26.425 18.7 26.95 18.3 27.15 17.9L28.625 14.95C29.35 13.35 30.65 13.35 31.45 14.95Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const TruckFast = () => {
  return (
    <>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M29.9995 35H32.4995C35.2495 35 37.4995 32.75 37.4995 30V5H14.9994C11.2494 5 7.97441 7.07498 6.27441 10.125"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 42.5C5 46.65 8.35 50 12.5 50H15C15 47.25 17.25 45 20 45C22.75 45 25 47.25 25 50H35C35 47.25 37.25 45 40 45C42.75 45 45 47.25 45 50H47.5C51.65 50 55 46.65 55 42.5V35H47.5C46.125 35 45 33.875 45 32.5V25C45 23.625 46.125 22.5 47.5 22.5H50.725L46.45 15.025C45.55 13.475 43.9 12.5 42.1 12.5H37.5V30C37.5 32.75 35.25 35 32.5 35H30"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 55C22.7614 55 25 52.7615 25 50C25 47.2385 22.7614 45 20 45C17.2386 45 15 47.2385 15 50C15 52.7615 17.2386 55 20 55Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40 55C42.7615 55 45 52.7615 45 50C45 47.2385 42.7615 45 40 45C37.2385 45 35 47.2385 35 50C35 52.7615 37.2385 55 40 55Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55 30V35H47.5C46.125 35 45 33.875 45 32.5V25C45 23.625 46.125 22.5 47.5 22.5H50.725L55 30Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 20H20"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 27.5H15"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 35H10"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const CardsIcon = () => {
  return (
    <>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 31.5247H47.5"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47.5 25.6995V43.5745C47.425 50.6995 45.475 52.4995 38.05 52.4995H14.4501C6.90007 52.4995 5 50.6245 5 43.1745V25.6995C5 18.9495 6.575 16.7745 12.5 16.4245C13.1 16.3995 13.7501 16.3745 14.4501 16.3745H38.05C45.6 16.3745 47.5 18.2495 47.5 25.6995Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M55 16.825V34.3C55 41.05 53.425 43.225 47.5 43.575V25.7C47.5 18.25 45.6 16.375 38.05 16.375H14.4501C13.7501 16.375 13.1 16.4 12.5 16.425C12.575 9.3 14.5251 7.5 21.9501 7.5H45.55C53.1 7.5 55 9.375 55 16.825Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M13.125 44.5253H17.4249"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M22.7734 44.5253H31.3735"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const BrownClock = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_191_26412)">
          <path
            d="M11.1283 10.7525L8.93245 9.44207C8.54995 9.21541 8.23828 8.66999 8.23828 8.22374V5.31958"
            stroke="#B9A193"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.83268 4.24996C1.94727 5.43288 1.41602 6.90621 1.41602 8.49996C1.41602 12.41 4.58935 15.5833 8.49935 15.5833C12.4093 15.5833 15.5827 12.41 15.5827 8.49996C15.5827 4.58996 12.4093 1.41663 8.49935 1.41663C7.48643 1.41663 6.51602 1.62913 5.64477 2.01871"
            stroke="#B9A193"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_191_26412">
            <rect width="17" height="17" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const BrownCall = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_191_26410)">
          <path
            d="M10.3494 4.25704C10.2219 4.43413 10.1298 4.59704 10.0661 4.75288C10.0023 4.90163 9.9669 5.05038 9.9669 5.18496C9.9669 5.35496 10.0165 5.52496 10.1157 5.68788C10.2077 5.85079 10.3423 6.02079 10.5123 6.19079L11.0507 6.75038C11.1286 6.82829 11.164 6.92038 11.164 7.03371C11.164 7.09038 11.1569 7.13996 11.1427 7.19663C11.1215 7.25329 11.1002 7.29579 11.0861 7.33829C10.9586 7.57204 10.739 7.87663 10.4273 8.24496C10.1086 8.61329 9.76857 8.98871 9.40023 9.36413C9.01773 9.73954 8.6494 10.0866 8.27398 10.4054C7.90565 10.717 7.60107 10.9295 7.36023 11.057C7.32482 11.0712 7.28232 11.0925 7.23273 11.1137C7.17607 11.135 7.1194 11.142 7.05565 11.142C6.93523 11.142 6.84315 11.0995 6.76523 11.0216L6.2269 10.4904C6.04982 10.3133 5.87982 10.1787 5.7169 10.0937C5.55398 9.99454 5.39107 9.94496 5.21399 9.94496C5.0794 9.94496 4.93773 9.97329 4.7819 10.037C4.62607 10.1008 4.46315 10.1929 4.28607 10.3133L1.94148 11.9779C1.75732 12.1054 1.62982 12.2541 1.5519 12.4312C1.48107 12.6083 1.43857 12.7854 1.43857 12.9837C1.43857 13.2387 1.49524 13.5008 1.61565 13.7558C1.73607 14.0108 1.8919 14.2516 2.09732 14.4783C2.4444 14.8608 2.8269 15.137 3.25898 15.3141C3.68398 15.4912 4.1444 15.5833 4.64023 15.5833C5.36273 15.5833 6.13482 15.4133 6.9494 15.0662C7.76398 14.7191 8.57857 14.2516 9.38607 13.6637C10.2007 13.0687 10.9727 12.41 11.7094 11.6804C12.439 10.9437 13.0977 10.1716 13.6857 9.36413C14.2665 8.55663 14.734 7.74913 15.074 6.94871C15.414 6.14121 15.584 5.36913 15.584 4.63246C15.584 4.15079 15.499 3.69038 15.329 3.26538C15.159 2.83329 14.8898 2.43663 14.5144 2.08246C14.0611 1.63621 13.5652 1.41663 13.0411 1.41663C12.8427 1.41663 12.6444 1.45913 12.4673 1.54413C12.2832 1.62913 12.1202 1.75663 11.9927 1.94079"
            stroke="#B9A193"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_191_26410">
            <rect
              width="17"
              height="17"
              fill="white"
              transform="matrix(-1 0 0 1 17 0)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

const TwentyFourSupport = () => {
  return (
    <>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45 47.1492H43.1C41.1 47.1492 39.2 47.9242 37.8 49.3242L33.525 53.5495C31.575 55.4745 28.4 55.4745 26.45 53.5495L22.175 49.3242C20.775 47.9242 18.85 47.1492 16.875 47.1492H15C10.85 47.1492 7.5 43.8245 7.5 39.7245V12.4493C7.5 8.34934 10.85 5.02441 15 5.02441H45C49.15 5.02441 52.5 8.34934 52.5 12.4493V39.7245C52.5 43.7995 49.15 47.1492 45 47.1492Z"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M17.5 22.8995C17.5 20.5745 19.4 18.6743 21.725 18.6743C24.05 18.6743 25.95 20.5745 25.95 22.8995C25.95 27.5995 19.275 28.0995 17.8 32.5745C17.5 33.4995 18.275 34.4245 19.25 34.4245H25.95"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M40.0995 34.3997V20.1248C40.0995 19.4748 39.6745 18.8996 39.0495 18.7246C38.4245 18.5496 37.7495 18.7996 37.3995 19.3496C35.5995 22.2496 33.6495 25.5497 31.9495 28.4497C31.6745 28.9247 31.6745 29.5497 31.9495 30.0247C32.2245 30.4997 32.7495 30.7995 33.3245 30.7995H42.4995"
          stroke="#40B2AA"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const ArrowUp = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="arrow-left-2 1">
          <path
            id="Vector"
            d="M2.77476 12.4994C2.77476 12.3411 2.83309 12.1827 2.95809 12.0577L8.39142 6.62441C9.27476 5.74108 10.7248 5.74108 11.6081 6.62441L17.0414 12.0577C17.2831 12.2994 17.2831 12.6994 17.0414 12.9411C16.7997 13.1827 16.3997 13.1827 16.1581 12.9411L10.7248 7.50775C10.3248 7.10775 9.67476 7.10775 9.27476 7.50775L3.84142 12.9411C3.59976 13.1827 3.19976 13.1827 2.95809 12.9411C2.84142 12.8161 2.77476 12.6577 2.77476 12.4994Z"
            fill="#B9B9B9"
          />
        </g>
      </svg>
    </>
  );
};

export {
  GreenCardBag,
  SearchIcon,
  ShoppingBag,
  OrdibeheshtLogo,
  SortIcon,
  ArrowSquareLeft,
  WhatsApp,
  Spotify,
  BrownTwitterIcon,
  GreenTwitterIcon,
  Viber,
  Telegram,
  GreenLinkdin,
  Setting,
  BrownInstagram,
  GreenInstagram,
  HeartIcon,
  GreenYoutube,
  ShareIcon,
  BrownCircleProfile,
  OrderListIcon,
  CloseSquare,
  BrownFacebook,
  BrownSwitchIcon,
  Location,
  MedalStar,
  TruckFast,
  CardsIcon,
  BrownClock,
  BrownCall,
  TwentyFourSupport,
  ArrowUp,
  AddBtn,
  FullStarIcon,
  HalfStarIcon,
};
